class FirehawkCRMForm {

	formElementId = null;
	formId = null;
	cancelRedirectTo = null;
	confirmationRedirectTo = null;
	grids = {}
	htmlDocs = {}
	addressPickers = {}
	cartItems = {}
	mandatoryCartItems = []
	mandatoryPackageItems = []
	cartShippingMethods = null
	noShipping = false
	disablePaymentPlans = false
	attachPaymentToOrder = true
	initialFormValues = {}
	draftSaveParams = {}

	savePages = false;

	entityId = null
	entityType = null
	cartId = null

	redirectWithCart = false

	quoteId = null
	existingType = null
	paramValue = null
	formTemplate = null
	currencySymbol = null

	channel = null;

	scrollFormOffsetElement = null
	scrollFormTopOffset = 0

	extraFormData = {}
	teamData = null

	packages = []

	selectedPackages = {}
	showPackagePricing = false

	formCalculator = new FirehawkCRMFormCalculator()

	visitedPages = {}

	isSavingForm = false

	geoFieldValues = {}

	backHidden = false

	updateExternalPlanNameClasses = null

	debounceCheckRelations = lodash.debounce(() => {
		this.checkRelations()
	}, 160)

	debounceActivePageBlocks = lodash.debounce(() => {
		this.checkActivePageBlocked()
	}, 160)

	debounceChangeCheckForm = lodash.debounce(() => {
		this.checkForm(true)
	}, 160)

	constructor(element, formId) {
		this.formElementId = element;
		this.formId = formId;
	}

	handleInitialValues() {
		if (!this.initialFormValues) return;

		for (let key in this.initialFormValues) {
			var value = this.initialFormValues[key]
			let eventTarget = jQuery(`#${key}`);
			let isChecked = eventTarget.is(":checked");

			let cartItem = jQuery(eventTarget).data('cart-item');
			let cartItemAction = jQuery(eventTarget).data('cart-item-action');
			let fieldId = eventTarget.attr('name');

			if (this.grids[fieldId]) {
				var grid = this.grids[fieldId]
				grid.defaultValue = value
				grid.selectItem(value)
			}

			if (fieldId && fieldId.length) {
				if (cartItem && cartItemAction === "add" && isChecked) {
					this.updateCart(fieldId, cartItem, 1);
				} else {
					this.removeFromCart(fieldId);
				}
			}
		}
	}

	setupForm() {
		this.configureGoogleSearch();
		let me = this;

		jQuery(`${this.formElementId} .select2`).select2({
			theme: "bootstrap4",
			allowClear: true
		});

		jQuery(`${this.formElementId} input.input-masked`).each(function (index) {

			var name = jQuery(this).attr("name")
			var alias = jQuery(this).data("mask-alias")
			var format = `${jQuery(this).data("mask-format") || ''}`
			var placeholder = `${jQuery(this).data("mask-placeholder") || jQuery(this).attr("placeholder") || ''}`
			var prefix = `${jQuery(this).data("mask-prefix") || ''}`

			if (!alias || !alias.length) alias = null
			if (!placeholder || !placeholder.length) placeholder = null

			var config = {
				prefix: prefix || null,
				placeholder: placeholder || format,
				rightAlign: false
			}

			if (alias == "datetime" || alias == "date") {
				config.inputFormat = format
				jQuery(this).inputmask(alias || format, config);
			} else {
				config.alias = alias || null

				if (format && format.length) {
					config.mask = format
				}

				if (prefix && prefix.length) {
					Inputmask.extendAliases({
						[name]: {
							prefix: prefix,
						  	alias: alias,
						  	placeholder: placeholder || format
						}
					});
					config.alias = name
				}
				jQuery(this).inputmask(alias, config);
			}

		})

		jQuery(`${this.formElementId} .firehawk-crm-form-grid-picker`).each(function (index) {
			if (jQuery(this).attr('name')) {
				me.buildGridPicker(jQuery(this).attr('name'))
			}
		})

		jQuery(`${this.formElementId} .firehawk-crm-form-html-doc`).each(function (index) {
			if (jQuery(this).attr('name')) {
				me.buildHtmlDocument(jQuery(this).attr('name'))
			}
		})

		jQuery(`${this.formElementId} .firehawk-crm-form-address-picker`).each(function (index) {
			if (jQuery(this).attr('name')) {

				me.buildAddressPicker(jQuery(this).attr('name'), jQuery(this).data('default-country'))
			}
		})

		jQuery(`${this.formElementId} .form-element input[type='tel']`).each(function (index) {
			let defaultCountry = jQuery(this).data("default-country") || null

			window.intlTelInput(jQuery(this)[0], {
				initialCountry: "auto",
				strictMode: true,
				geoIpLookup: callback => {
					fetch("https://ipapi.co/json")
					.then(res => res.json())
					.then(data => callback(data.country_code))
					.catch(() => callback("us"));
				},
				utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.9.3/build/js/utils.js",
			});
		})

		jQuery(this.formElementId).delegate(".form-element input[type='tel']", 'blur', function(event) {

			let elValue = jQuery(this).val();
			const iti = window.intlTelInput.getInstance(this);
			const countryCode = iti.getSelectedCountryData().iso2

			if (countryCode === "gb") {
				const formattedNumber = elValue.replace(/(\d{5})\s(\d{3})(\d{3})/, '$1 $2 $3');
				jQuery(this).val(formattedNumber)
			}

		});


		jQuery(`${this.formElementId} .time-picker-dropdown`).each(function (index) {
			var select = jQuery(this)
			var defaultValue = jQuery(this).data("value")

			if (defaultValue && moment(defaultValue).isValid()) {
				defaultValue = moment(defaultValue).format("HH:mm")
			}

			select.simpleTimePicker({
				text: {
					hour: 'Hour',
					minute: 'Minute'
				},
				time: {
					selected: defaultValue
				},
				css: 'form-select'
			});
		})

		jQuery(`${this.formElementId} .select2-api`).each(function (index) {
			var select = jQuery(this)
			var objectTemplate = jQuery(this).data("api-es-objecttemplate") || null;
			var defaultValue = jQuery(this).data("defaultvalue") || null;
			var isMultiSelect = jQuery(this).prop('multiple') == true

			select.select2({
				theme: "bootstrap4",
				allowClear: true,
				placeholder: "Select item",
				closeOnSelect: isMultiSelect ? false : true,
				delay: 250,
				templateResult: function (data) {
					var template = select.data("template") || null;
					if (!template) return data.text
					return me.formatTemplateResults(template, data)
				},
				ajax: {
					url: function () {
						return ajax_var.url;
					},
					data: function (params) {
						let currentPage = params.page || 1;
						var tagfilters = select.data("api-es-tagfilters") || null;
						var customTerms = select.data("api-es-customterms") || null;
						var conditionalFilters = select.data("api-es-conditionalfilters") || null
						var customFilters = select.data("api-es-customfilters") || null
						var hideDiscontinued = select.data("api-es-hidediscontinued")
						var onlyShowInWeb = select.data("api-es-only-show-in-web") == "yes";

						var index = select.data("api-es-index") || null;
						let pageSize = select.data("api-size") || 50;
						var type = select.data("api-es-type") || null;
						var team = fcrm_options.team || null
						var term = params.term ? '*' + params.term + '*' : null
						var query = {
							hideArchived: true,
							hideDiscontinued: hideDiscontinued,
							onlyShowInWeb: onlyShowInWeb
						}

						if (customTerms && customTerms.length) {
							customTerms = customTerms.map((m) => {
								var paramValue = m.value;
								if (paramValue && typeof paramValue == "string") {
									if (paramValue.startsWith("{")) {
										paramValue = paramValue.replace(/{/g, "")
										paramValue = paramValue.replace(/}/g, "")
										paramValue = paramValue.trim();
									}

									if (paramValue.startsWith("user.")) {
										var field = paramValue.slice(5);
										if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
											paramValue = fcrm_options.user[field];
										}
									}
								}

								if (paramValue == "true") paramValue = true;
								if (paramValue == "false") paramValue = false;
								return {
									[m.field]: paramValue
								}
							})
							query['customTerms'] = customTerms;
						}
						if (conditionalFilters) {
							query['conditionalFilters'] = conditionalFilters
						}
						if (customFilters) {
							query['customFilters'] = customFilters
						}

						if (term) {
							query['query'] = term;
						}
						if (index) {
							query['index'] = index;
							query['sorting'] = [{
								'name.keyword': {
									order: 'asc'
								}
							}]

							query['size'] = pageSize;
							query['from'] = pageSize * (currentPage-1);
						}

						if (type) {
							query['type'] = type;
						}

						if (team) {
							query['teamId'] = team;
							query['team'] = team;
						}

						var tags = tagfilters ? tagfilters.split(',') || [] : []

						var mergeData = {
							user: fcrm_options.user
						}
						tags = tags.map(function (tag) {
							return me.mergeTags(tag, mergeData)
						})

						if (tagfilters) {
							query['tags'] = tags.length > 0 ? tags : null;
						}

						var currentForm = jQuery(me.formElementId);
						jQuery.each(select.data(), function (i, v) {
							if (i.startsWith("apiParam")) {
								var valueArray = v.split(":");
								if (valueArray && valueArray.length == 2) {
									var paramKey = valueArray[0] || null;
									var paramValue = valueArray[1] || null;
									if (paramValue) {
										if (paramValue.startsWith("{")) {
											paramValue = paramValue.replace(/{/g, "")
											paramValue = paramValue.replace(/}/g, "")
											paramValue = paramValue.trim();
											if (paramValue == "team.id" && team) {
												query['teamId'] = team;
												query['team'] = team;
											} else if (paramValue.startsWith("user.")) {
												var field = paramValue.slice(5);
												if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
													if (fcrm_options.user[field]) {
														query[paramKey] = fcrm_options.user[field]
													}
												}
											} else if (paramValue.startsWith("self.")) {
												var field = paramValue.slice(5);
												var fieldValue = jQuery(currentForm).find('[name=' + field + ']');
												if (jQuery(fieldValue).is(':radio') || jQuery(fieldValue).is(':checkbox')) {
													fieldValue = jQuery(currentForm).find('[name=' + field + ']:checked');
												}
												query[paramKey] = fieldValue.val();
											}
										} else {
											if (paramValue == "true") paramValue = true;
											if (paramValue == "false") paramValue = false;
											query[paramKey] = paramValue;
										}
									}
								}
							}
						});

						return { 
							action: "form_picker_request",
							query: query,
							url: select.data("api-url")
						};
					},
					processResults: function (data, params) {
						params.page = params.page || 1;
						let pageSize = select.data("api-size") || 50;

						if (data && data.results) {
							let totalResults = data.total || 0;
							return {
								results: data.results || [],
								pagination: {
									more: (params.page * pageSize) < totalResults
								}
							}
						} else if (data && data.hits && data.hits.hits) {
							let hits = data.hits.hits;
							let totalResults = data.hits.total || 0;
							if (hits.length > 0) {
								hits = hits.map((hit) => {
									var name = '';
									if (hit && hit._source && objectTemplate && objectTemplate.length) {
										var compiled = lodash.template(objectTemplate)
										name = compiled(hit._source)
									}

									if (hit && hit._source && hit._source.name && !name) {
										name = hit._source.name || ''
									}
									
									var newHit = {
										"id": hit._id || null,
										"text": name,
										"source": hit._source
									};
									return newHit;
								})
							}
							return {
								results: hits || [],
								pagination: {
									more: (params.page * pageSize) < totalResults
								}
							}
						}

						return {
							results: [],
							pagination: {
								more: false
							}
						}
					},
					cache: true
				}
			});
			if (!jQuery.isEmptyObject(defaultValue)) {
				jQuery(select).val(defaultValue && defaultValue.id)
				jQuery(select).select2("trigger", "select", {
					data: defaultValue
				});
			}
			// Causes an issue with checking relations before all select boxes have been built
			// checkRelations();
		})

		this.updatePageHtmlDocuments()
	}

	initialiseFormFieldGroup(groupKey) {
		this.configureGoogleSearch();
		let me = this;

		let groups = jQuery(this.formElementId).find(`.form-element[data-groupkey="${groupKey}"`)

		groups.find(".form-control.select2").each(function() {
			let field = jQuery(this)
			field.select2({
				theme: "bootstrap4",
				allowClear: true
			})
		})

		groups.find("input.input-masked").each(function (index) {

			var name = jQuery(this).attr("name")
			var alias = jQuery(this).data("mask-alias")
			var format = `${jQuery(this).data("mask-format") || ''}`
			var placeholder = `${jQuery(this).data("mask-placeholder") || jQuery(this).attr("placeholder") || ''}`
			var prefix = `${jQuery(this).data("mask-prefix") || ''}`

			if (!alias || !alias.length) alias = null
			if (!placeholder || !placeholder.length) placeholder = null

			var config = {
				prefix: prefix || null,
				placeholder: placeholder || format,
				rightAlign: false
			}

			if (alias == "datetime" || alias == "date") {
				config.inputFormat = format
				jQuery(this).inputmask(alias || format, config);
			} else {
				config.alias = alias || null

				if (format && format.length) {
					config.mask = format
				}

				if (prefix && prefix.length) {
					Inputmask.extendAliases({
						[name]: {
							prefix: prefix,
						  	alias: alias,
						  	placeholder: placeholder || format
						}
					});
					config.alias = name
				}
				jQuery(this).inputmask(alias, config);
			}

		})

		groups.find(".firehawk-crm-form-grid-picker").each(function (index) {
			if (jQuery(this).attr('name')) {
				me.buildGridPicker(jQuery(this).attr('name'))
			}
		})

		groups.find(".firehawk-crm-form-html-doc").each(function (index) {
			if (jQuery(this).attr('name')) {
				me.buildHtmlDocument(jQuery(this).attr('name'))
			}
		})

		groups.find(".firehawk-crm-form-address-picker").each(function (index) {
			if (jQuery(this).attr('name')) {
				me.buildAddressPicker(jQuery(this).attr('name'), jQuery(this).data('default-country'))
			}
		})

		groups.find(".form-element input[type='tel']").each(function (index) {
			let defaultCountry = jQuery(this).data("default-country") || null

			window.intlTelInput(jQuery(this)[0], {
				initialCountry: "auto",
				strictMode: true,
				geoIpLookup: callback => {
					fetch("https://ipapi.co/json")
					.then(res => res.json())
					.then(data => callback(data.country_code))
					.catch(() => callback("us"));
				},
				utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.9.3/build/js/utils.js",
			});
		})


		groups.find(".time-picker-dropdown").each(function (index) {
			var select = jQuery(this)
			var defaultValue = jQuery(this).data("value")

			if (defaultValue && moment(defaultValue).isValid()) {
				defaultValue = moment(defaultValue).format("HH:mm")
			}

			select.simpleTimePicker({
				text: {
					hour: 'Hour',
					minute: 'Minute'
				},
				time: {
					selected: defaultValue
				},
				css: 'form-select'
			});
		})

		groups.find(".select2-api").each(function (index) {
			var select = jQuery(this)
			var objectTemplate = jQuery(this).data("api-es-objecttemplate") || null;
			var defaultValue = jQuery(this).data("defaultvalue") || null;
			var isMultiSelect = jQuery(this).prop('multiple') == true

			select.select2({
				theme: "bootstrap4",
				allowClear: true,
				placeholder: "Select item",
				closeOnSelect: isMultiSelect ? false : true,
				delay: 250,
				templateResult: function (data) {
					var template = select.data("template") || null;
					if (!template) return data.text
					return me.formatTemplateResults(template, data)
				},
				ajax: {
					url: function () {
						return ajax_var.url;
					},
					data: function (params) {
						let currentPage = params.page || 1;
						var tagfilters = select.data("api-es-tagfilters") || null;
						var customTerms = select.data("api-es-customterms") || null;
						var conditionalFilters = select.data("api-es-conditionalfilters") || null
						var customFilters = select.data("api-es-customfilters") || null
						var hideDiscontinued = select.data("api-es-hidediscontinued")
						var onlyShowInWeb = select.data("api-es-only-show-in-web") == "yes";

						var index = select.data("api-es-index") || null;
						var type = select.data("api-es-type") || null;
						var team = fcrm_options.team || null
						var term = params.term ? '*' + params.term + '*' : null
						var query = {
							hideArchived: true,
							hideDiscontinued: hideDiscontinued,
							onlyShowInWeb: onlyShowInWeb
						}

						if (customTerms && customTerms.length) {
							customTerms = customTerms.map((m) => {
								var paramValue = m.value;
								if (paramValue) {
									if (paramValue.startsWith("{")) {
										paramValue = paramValue.replace(/{/g, "")
										paramValue = paramValue.replace(/}/g, "")
										paramValue = paramValue.trim();
									}

									if (paramValue.startsWith("user.")) {
										var field = paramValue.slice(5);
										if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
											paramValue = fcrm_options.user[field];
										}
									}
								}

								if (paramValue == "true") paramValue = true;
								if (paramValue == "false") paramValue = false;
								return {
									[m.field]: paramValue
								}
							})
							query['customTerms'] = customTerms;
						}
						if (conditionalFilters) {
							query['conditionalFilters'] = conditionalFilters
						}
						if (customFilters) {
							query['customFilters'] = customFilters
						}

						if (term) {
							query['query'] = term;
						}
						if (index) {
							query['index'] = index;
							query['sorting'] = [{
								'name.keyword': {
									order: 'asc'
								}
							}]
							query['size'] = pageSize;
							query['from'] = pageSize * (currentPage-1);
						}
						if (type) {
							query['type'] = type;
						}
						if (team) {
							query['teamId'] = team;
							query['team'] = team;
						}

						var tags = tagfilters ? tagfilters.split(',') || [] : []

						var mergeData = {
							user: fcrm_options.user
						}
						tags = tags.map(function (tag) {
							return me.mergeTags(tag, mergeData)
						})

						if (tagfilters) {
							query['tags'] = tags.length > 0 ? tags : null;
						}

						var currentForm = jQuery(me.formElementId);
						jQuery.each(select.data(), function (i, v) {
							if (i.startsWith("apiParam")) {
								var valueArray = v.split(":");
								if (valueArray && valueArray.length == 2) {
									var paramKey = valueArray[0] || null;
									var paramValue = valueArray[1] || null;
									if (paramValue) {
										if (paramValue.startsWith("{")) {
											paramValue = paramValue.replace(/{/g, "")
											paramValue = paramValue.replace(/}/g, "")
											paramValue = paramValue.trim();
											if (paramValue == "team.id" && team) {
												query['teamId'] = team;
												query['team'] = team;
											} else if (paramValue.startsWith("user.")) {
												var field = paramValue.slice(5);
												if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
													if (fcrm_options.user[field]) {
														query[paramKey] = fcrm_options.user[field]
													}
												}
											} else if (paramValue.startsWith("self.")) {
												var field = paramValue.slice(5);
												var fieldValue = jQuery(currentForm).find('[name=' + field + ']');
												if (jQuery(fieldValue).is(':radio') || jQuery(fieldValue).is(':checkbox')) {
													fieldValue = jQuery(currentForm).find('[name=' + field + ']:checked');
												}
												query[paramKey] = fieldValue.val();
											}
										} else {
											if (paramValue == "true") paramValue = true;
											if (paramValue == "false") paramValue = false;
											query[paramKey] = paramValue;
										}
									}
								}
							}
						});

						return { 
							action: "form_picker_request",
							query: query,
							url: select.data("api-url")
						};
					},
					processResults: function (data, params) {
						params.page = params.page || 1;
						let pageSize = select.data("api-size") || 50;

						if (data && data.results) {
							let totalResults = data.total || 0;
							return {
								results: data.results || [],
								pagination: {
									more: (params.page * pageSize) < totalResults
								}
							}
						} else if (data && data.hits && data.hits.hits) {
							let hits = data.hits.hits;
							let totalResults = data.hits.total || 0;
							if (hits.length > 0) {
								hits = hits.map((hit) => {
									var name = '';
									console.log("objectTemplate", objectTemplate, data)
									if (hit && hit._source && objectTemplate && objectTemplate.length) {
										var compiled = lodash.template(objectTemplate)
										name = compiled(hit._source)
										console.log("name", name)
									}
									if (hit && hit._source && hit._source.name) {
										name = hit._source.name || ''
									}
									var newHit = {
										"id": hit._id || null,
										"text": name,
										"source": hit._source
									};
									return newHit;
								})
							}
							return {
								results: hits || [],
								pagination: {
									more: (params.page * pageSize) < totalResults
								}
							}
						}
						return {
							results: [],
							pagination: {
								more: false
							}
						}

					},
					cache: true
				}
			});

			if (!jQuery.isEmptyObject(defaultValue)) {
				jQuery(select).val(defaultValue && defaultValue.id)
				jQuery(select).select2("trigger", "select", {
					data: defaultValue
				});
			}
		})
	}

	loadCheckout() {
		this.toggleNextButton(false);
		let me = this;
		event.preventDefault();
		const eventTarget = jQuery(this);

		const buttonId = eventTarget.attr('id')
		const submitType = buttonId == "save-draft" ? "draft" : "save"

		if (me.isSavingForm) {
			return
		}

		me.showSaving(true);

		var currentForm = jQuery(me.formElementId)
		currentForm.find(".firehawk-checkout-loader").show()
		currentForm.find('.firehawk-checkout-shortcode').hide()

		if (me.checkForm()) {
			var formSaveApiPath = currentForm.data('api-url')
			var extraData = {};
			if (currentForm.data("extra-params")) {
				extraData = currentForm.data("extra-params")
			}
			var formSuccessMessage = eventTarget.data('success-message')
			var formSuccessTitle = eventTarget.data('success-title')
			var formSuccessConfirmButtonText = eventTarget.data('success-confirm-button-text')
			var ignoreSuccessModal = eventTarget.data('no-success-modal')

			var formData = new FormData()

			currentForm.find("form").each(function () {
				var pageFormData = new FormData(jQuery(this).get(0))
				pageFormData.forEach(function (value, key) {
					formData.append(key, value)
				})
			})

			jQuery(`${me.formElementId} .tag-picker`).each(function (index) {
				var values = []
				var fieldName = jQuery(this).attr('name');
				if (!fieldName) return

				jQuery(this).find(".tag.selected").each(function () {
					var value = jQuery(this).data("value")
					if (value) {
						values.push(value)
						formData.append(fieldName + '[]', value)
					}
				})
			})

			jQuery(`${me.formElementId} .time-picker-dropdown`).each(function (index) {
				var values = []
				var fieldName = jQuery(this).attr('name');
				if (!fieldName) return
				var value = jQuery(this).simpleTimePicker("getTime");
				formData.append(fieldName, value)
			})

			if (me.existingType && me.existingType.length) {
				formData.append("existingType", me.existingType);
			}

			if (me.entityId && me.entityId.length) {
				formData.append("paramValue", me.entityId);
			} else if (me.paramValue && me.paramValue.length) {
				formData.append("paramValue", me.paramValue);
			}

			if (me.quoteId && me.quoteId.length) {
				formData.append("quoteId", me.quoteId);
			}

			if (me.formTemplate && me.formTemplate.length) {
				formData.append("formTemplate", me.formTemplate);
			}

			me.gridPickerValues().forEach(function (item, index) {
				formData.append(item.id, item.value)
			})

			for (let key in me.selectedPackages) {
				formData.append(key, me.selectedPackages[key])
			}

			me.addressPickerValues().forEach(function (item, index) {
				formData = me.appendFormArray(formData, {
					[item.id]: [item.value]
				})
			})

			jQuery.each(jQuery(currentForm).data(), function (i, v) {
				if (i.startsWith("apiParam")) {
					var valueArray = v.split(":");
					if (valueArray && valueArray.length == 2) {
						var paramKey = valueArray[0] || null;
						var paramValue = valueArray[1] || null;
						if (paramValue) {
							if (paramValue.startsWith("{")) {
								paramValue = paramValue.replace(/{/g, "")
								paramValue = paramValue.replace(/}/g, "")
								paramValue = paramValue.trim();
								if (paramValue == "team.id" && team) {
									formData.append(paramKey, fcrm_options.team)
								} else if (paramValue == "user.id") {
									// do nothing
								} else if (paramValue.startsWith("user.")) {
									var field = paramValue.slice(5);
									if (fcrm_options && fcrm_options.user && (fcrm_options.user["user_id"] == 0 || fcrm_options.user["user_id"])) {
										formData.append("wp_user_id", fieldValue);
									}
									if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
										var fieldValue = fcrm_options.user[field];
										formData.append(paramKey, fieldValue);
									}
								} else if (paramValue.startsWith("self.")) {
									var field = paramValue.slice(5);
									var fieldValue = jQuery(currentForm).find('[name=' + field + ']').val();
									formData.append(paramKey, fieldValue);
								}
							} else {
								if (paramValue == "true") paramValue = true;
								if (paramValue == "false") paramValue = false;
								formData.append(paramKey, paramValue);
							}
						}
					}
				}
			});

			if (!formSaveApiPath || !formSaveApiPath.length) {
				return;
			}

			if (formSaveApiPath && formSaveApiPath.startsWith("/")) {
				formSaveApiPath = formSaveApiPath.slice(1);
			}

			const newFormData = me.formatData(formData)
			for (var key in extraData) {
				newFormData.set(key, extraData[key])
			}

			for (var key in this.extraFormData) {
				newFormData.append(key, this.extraFormData[key])
			}

			let cartItems = this.getDefaultCartItems()
			
			for (let i in cartItems) {
				let index = +i
				let cartItem = cartItems[index]
				for (let key in cartItem) {
					newFormData.append(`cartItems[${i}][${key}]`, cartItem[key])
				}
			}

			if (Array.isArray(me.mandatoryCartItems) && me.mandatoryCartItems.length) {
				me.mandatoryCartItems.forEach((item, i) => {
					if (item.product_id) {
						item.stock = item.product_id
						delete item.product_id
					}

					for (let key in item) {
						newFormData.append(`mandatoryCartItems[${i}][${key}]`, item[key])
					}
				});
			}

			newFormData.append('action', 'form_submit');
			newFormData.append('team', fcrm_options.team);
			newFormData.append("formId", me.formId);
			newFormData.append('url', formSaveApiPath);
			newFormData.append('security', ajax_var.nonce);
			
			jQuery.ajax({
				type: "POST",
				url: ajax_var.url,
				data: newFormData,
				processData: false,
				contentType: false,
				dataType: 'json',
			}).done((response) => {
				let success = response?.success == true;
				let result = response?.data
				if (result && result.id && result.id.length) {
					me.entityId = result.id

					var extraParams = {
						disableCookie: true
					}
					if (result.quoteId) {
						me.quoteId = result.quoteId
						extraParams.quoteId = result.quoteId
					}

					var paymentChannel = result && result.client && result.client.channel || me.channel
					if (paymentChannel && paymentChannel.length) {
						extraParams.channel = paymentChannel
					}

					me.onFormSuccessAddCart(result.id, result.contact, extraParams, formSuccessMessage, formSuccessTitle, formSuccessConfirmButtonText, true, (success, error) => {
						console.log(success, error)
						if (success) {
							let cartView = jQuery(me.formElementId).find('.firehawk-checkout-shortcode')
							let shortcodeParams = cartView.data('shortcode-params') || {}
							shortcodeParams.cart = this.cartId || null
							if (paymentChannel && paymentChannel.length) {
								shortcodeParams.channel = paymentChannel
							}
							me.renderCheckoutShortcode(shortcodeParams)
						} else {
							
						}
					}, true)
				} else {
					jQuery(me.formElementId).find(".firehawk-checkout-loader").hide()
					me.showSaving(false);
					me.goBackPage()
				}
			}).fail(function (xhr, status, error) {
				console.error("Error", error)
				jQuery(me.formElementId).find(".firehawk-checkout-loader").hide()
				me.showSaving(false);
				me.goBackPage()
			}).always(function () {

			});
		} else {
			jQuery(me.formElementId).find(".firehawk-checkout-loader").hide()
			me.showSaving(false);
			me.goBackPage()
		}
	}

	renderCheckoutShortcode(params, retries = 0, maxRetries = 3) {
		if (maxRetries > 0 && retries >= maxRetries) {
			this.showSaving(false);
			this.goBackPage()
			return;
		}

		jQuery.ajax({
			method: "POST",
			url: ajax_var.url,
			data: {
				action: 'shortcode',
				content: 'fh_checkout',
				params: params || {}
			}
		}).done((response) => {
			if (!response || response && response.success == false) {
				this.renderCheckoutShortcode(params, retries + 1, maxRetries)
			} else {
				jQuery(this.formElementId).find(".firehawk-checkout-loader").hide()
				let cartView = jQuery(this.formElementId).find('.firehawk-checkout-shortcode')
				cartView.show()
				cartView.html(response);
				this.showSaving(false);
			}
		}).fail(function (xhr, status, error) {
			console.error(error);
			this.renderCheckoutShortcode(params, retries + 1, maxRetries)
		});
	}

	addListeners() {
		let me = this;

		jQuery(this.formElementId).delegate(".segment-button", "click", function (event) {
			const eventTarget = jQuery(this);
			const multiple = eventTarget.data("multiple")
			const segmentId = eventTarget.data("segment-id")
			const segmentValue = eventTarget.data("segment-value")
			const fieldId = eventTarget.parents(".form-element").data("field-id")
			const hideNextButton = eventTarget.data("hide-next-button")

			let hasMultiple = multiple === true || multiple === "true";
			me.updateSegmentValue(segmentId, segmentValue, fieldId, hasMultiple)
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			me.debounceChangeCheckForm()
		})

		jQuery(this.formElementId).delegate(".checkbox-list-item", "click", function (event) {
			const eventTarget = jQuery(this);
			const multiple = eventTarget.data("multiple")
			const itemId = eventTarget.data("item-id")
			const itemValue = eventTarget.data("item-value")

			let hasMultiple = multiple === true || multiple === "true";
			me.updateCheckboxListValue(itemId, itemValue, hasMultiple)
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			me.debounceChangeCheckForm()
		})

		jQuery(this.formElementId).delegate(".firehawk-crm.firehawk-crm-cart", "fh-cart:checkout-complete", function (event) {
			me.toggleNextButton(true);
			me.toggleBackButton(false);
			const currentActiveForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`)
			if (currentActiveForm) currentActiveForm.addClass('disable-wizard-links');
			
			currentActiveForm.find("form .next-button").click()
		});

		jQuery(this.formElementId).delegate(".firehawk-crm-form-package-picker .stick-table-nav .btn", "click", function(event) {
			var direction = "right"
			let optionSpan = window.innerWidth*0.55
			let scrollAmount = optionSpan / 2

			if (jQuery(this).hasClass("left")) direction = "left";

			let scrollDom = jQuery(this).parents(".firehawk-crm-form-package-picker").find(".table-responsive")
			let totalPackages = scrollDom.find("colgroup .package-col").length

			var containerPadding = 0

			let paddingRight = +jQuery(this).parents(".firehawk-crm-form-package-picker").css("padding-right").replace("px", "")
			let paddingLeft = +jQuery(this).parents(".firehawk-crm-form-package-picker").css("padding-left").replace("px", "")

			if (paddingRight) containerPadding += paddingRight
			if (paddingLeft) containerPadding += paddingLeft

			let currentPackage = Math.ceil(scrollDom.scrollLeft()/optionSpan)

			if (direction == "right") {
				let nextScroll = (optionSpan*(currentPackage+1)) - optionSpan/3
				scrollDom.animate({scrollLeft: nextScroll }, 600)
			} else {
				let nextScroll = (optionSpan*(currentPackage-1)) - optionSpan/3
				scrollDom.animate({scrollLeft: nextScroll }, 600)
			}
		})

		jQuery(this.formElementId).delegate('.form-element input', 'change', (event) => {
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate('.form-element textarea', 'change', (event) => {
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate('.form-element .time-picker-dropdown', 'change', (event) => {
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate('.form-element .select2-api', 'change', (event) => {
			var select = jQuery(this)
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()

			if (select.data("cart-item") == true || select.data("cart-item") == "true") {
				let fieldId = select.attr('id');
				if (select.val()) {
					me.updateCart(fieldId, select.val(), 1)
				} else {
					me.removeFromCart(fieldId)
				}
			}

			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate('.form-element .select2', 'change', (event) => {
			me.triggerCheckRelations();
			me.debounceActivePageBlocks()
			const eventTarget = jQuery(event.currentTarget);
			const selected = eventTarget.find('option:selected');
			const fieldId = eventTarget.attr('id');
			if (!fieldId || !fieldId.length) return;

			const cartItem = jQuery(selected).data('cart-item');
			if (cartItem) {
				const cartItemAction = jQuery(selected).data('cart-item-action');
				const cartItemQuantity = jQuery(selected).data('cart-item-quantity');

				if (selected && cartItemAction === "add") {
					me.updateCart(fieldId, cartItem, cartItemQuantity);
				} else {
					me.removeFromCart(fieldId)
				}
			} else {
				me.removeFromCart(fieldId)
			}

			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate('.sup-geo-field', 'blur', (event) => {
			const eventTarget = jQuery(event.currentTarget);
			const formElement = eventTarget.parent(".form-element")
			const fieldId = eventTarget.attr('id');
			if (!fieldId || !fieldId.length) return;

			var invalidLabel = eventTarget.data("invalid-label") || "Unable to validate field"
			let postcode = null;

			const value = postcode || eventTarget.val();

			if (value == this.geoFieldValues[fieldId]) {
				return
			}

			this.geoFieldValues[fieldId] = value

			formElement.addClass("verifying")

			let errorLabel = eventTarget.siblings(".text-danger")
			let fieldSpinner = eventTarget.siblings(".field-spinner")

			fieldSpinner.removeClass("d-none")
			errorLabel.addClass("d-none")

			let defaultCountry = jQuery(eventTarget).data("country") || null
			let searchDistance = jQuery(eventTarget).data("distance") || "15mi"
			let category = jQuery(eventTarget).data("category") || null
			let saveResultField = jQuery(eventTarget).data("save-result-field") || null
			let tagFilters = jQuery(eventTarget).data("geo-tags")

			var tags = tagFilters ? tagFilters.split(',') || [] : []

			var params = {
				postcode: value,
				country: defaultCountry,
				distance: searchDistance,
				category: category,
				tags: tags
			}
			jQuery.ajax({
				method: 'post',
				url: ajax_var.url,
				data: {
					action: 'validate_sup_geo_field',
					params: params
				}
			}).done((result) => {
				var fieldValid = result && result.valid == true
				formElement.removeClass("verifying")

				if (fieldValid) {
					eventTarget.addClass("valid").removeClass("invalid")
					formElement.addClass("valid").removeClass("invalid")
					errorLabel.addClass("d-none")
				} else {
					eventTarget.removeClass("valid").addClass("invalid")
					formElement.removeClass("valid").addClass("invalid")
					errorLabel.removeClass("d-none")
					errorLabel.html(invalidLabel)
				}

				if (saveResultField) {
					this.extraFormData[saveResultField] = result && result.value || null
				}
			}).fail(function (xhr, status, error) {
				console.error(error)
				formElement.removeClass("verifying")
				eventTarget.removeClass("valid").addClass("invalid")
				formElement.removeClass("valid").addClass("invalid")

				errorLabel.removeClass("d-none")
				errorLabel.html(invalidLabel)

				if (saveResultField) {
					this.extraFormData[saveResultField] = null
				}
			}).always(function () {
				fieldSpinner.addClass("d-none")
			});
		});

		jQuery(this.formElementId).delegate('.form-element input[type="checkbox"]', 'change', (event) => {
			// me.triggerCheckRelations();
			// me.debounceActivePageBlocks()
			const eventTarget = jQuery(event.currentTarget);

			const formElement = eventTarget.parents(".form-element")

			const isChecked = eventTarget.is(":checked");
			const checked = eventTarget.find(':checked');
			const cartItem = jQuery(eventTarget).data('cart-item');
			const cartItemAction = jQuery(eventTarget).data('cart-item-action');
			const fieldId = eventTarget.attr('name');
			if (!fieldId || !fieldId.length) return;

			if (cartItem && cartItemAction === "add" && isChecked) {
				me.updateCart(fieldId, cartItem, 1);
			} else {
				me.removeFromCart(fieldId);
			}

			me.debounceChangeCheckForm()
		});

		jQuery(this.formElementId).delegate(".wizard-item", "click", (event) => {
			const currentActiveForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`)
			var activePageId = currentActiveForm.data("page-id")
			if (currentActiveForm && currentActiveForm.hasClass('disable-wizard-links')) return;
			
			const eventTarget = jQuery(event.currentTarget);
			let pageId = eventTarget.data("page-id");
			let pageIndex = eventTarget.data("index");
			if (!pageId) return;

			var jumpDirection = null

			if (activePageId) {
				let activePageItem = jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item[data-page-id="${activePageId}"]`)
				let activePageIndex = activePageItem.data("index")

				if (activePageIndex != null && pageIndex != null) {
					jumpDirection = pageIndex > activePageIndex ? "next" : "back"
				}

				if (jumpDirection == "next") {
					if (currentActiveForm && currentActiveForm.hasClass('hide-next-btn')) return;

					for (let index = activePageIndex; index < pageIndex; index++) {
						console.log("PAGE", index)
						let nextPage = jQuery(`${this.formElementId} .firehawk-crm-form-page[data-index="${index}"]`)
						if (nextPage && nextPage.hasClass('disable-wizard-links')) return;
						if (nextPage && nextPage.hasClass('hide-next-btn')) return;
					}
				}
			}

			if (this.visitedPages[pageId] == true) {
				this.jumpToFormPage(pageId, jumpDirection)
			}
		})

		jQuery(this.formElementId).delegate('.form-element input[type="file"]', 'change', (event) => {
			const eventTarget = jQuery(event.currentTarget);
			let fileName = Array.from(eventTarget[0].files || []).map(x => x.name).join(', ')
			eventTarget.siblings('.custom-file-label').addClass("selected").html(fileName);
			eventTarget.addClass("changed")
		});

		jQuery(this.formElementId).delegate('.form-element input[type="file"].direct-upload', 'change', (event) => {
			const eventTarget = jQuery(event.currentTarget);
			var uploadUrl = eventTarget.data("upload-url")
			if (!uploadUrl) return

			this.uploadFileInput(eventTarget)
		});

		jQuery(this.formElementId).delegate(".add-group-btn", "click", (event) => {
			const eventTarget = jQuery(event.currentTarget);

			var groupKey = eventTarget.data("group-key");
			var fullGroupPath = eventTarget.data("group-path")

			this.onAddNewFieldGroup(groupKey, fullGroupPath, eventTarget)
		});

		jQuery(this.formElementId).delegate(".remove-group-btn", "click", (event) => {
			const eventTarget = jQuery(event.currentTarget);

			var groupKey = eventTarget.data("group-key");
			var fullGroupPath = eventTarget.data("group-path")

			this.onRemoveFieldGroup(groupKey, fullGroupPath, eventTarget)
		});

		jQuery(this.formElementId).delegate(".next-button", "click", (event) => {
			event.preventDefault();

			let formValid = me.checkForm()
			if (!formValid) {
				return
			}

			var currentForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`);

			if (currentForm.hasClass("hide-next-btn")) {
				return
			}

			var currentFormPosition = jQuery(currentForm).data('index');
			var currentPageId = currentForm.data("page-id")
			if (currentPageId) {
				me.visitedPages[currentPageId] = true
			}

			var callback = () => {
				me.checkPageRelations()
				jQuery(currentForm).removeClass('active');
				jQuery(`${me.formElementId} .firehawk-crm-form-page`).each(function () {
					var element = jQuery(this)
					var formPosition = element.attr('data-index');
					var formPageId = element.data('page-id');

					if (Number(formPosition) == (Number(currentFormPosition) + 1)) {
						if (element.hasClass("d-none")) {
							currentFormPosition = Number(currentFormPosition) + 1
						} else {
							element.addClass('active');
							me.updateGridPickers(element)
							if (formPageId) {
								me.visitedPages[formPageId] = true
							}
							if (element.hasClass('has-checkout')) {
								me.loadCheckout();
							}

							me.checkActivePageBlocked()
						}
					}
				});
				me.checkRelations()
				me.checkMergeLabels()
				me.updatePageWizard()
				me.updatePageHtmlDocuments()
				me.scrollFormToTop()
			}

			if (me.savePages) {
				me.saveCurrentPage(callback)
			} else {
				callback()
			}
		});

		jQuery(this.formElementId).delegate(".back-button", "click", (event) => {
			event.preventDefault();
			me.goBackPage();
		});

		jQuery(this.formElementId).delegate(".conf-next-button", "click", (event) => {
			event.preventDefault();

			if (me.checkForm()) {
				var currentForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`);
				var currentFormPosition = jQuery(currentForm).data('index');

				var callback = () => {
					me.checkPageRelations()
					jQuery(currentForm).removeClass('active');
					jQuery(`${me.formElementId} .firehawk-crm-form-page`).each(function () {
						var element = jQuery(this)
						var formPosition = element.attr('data-index');

						if (Number(formPosition) == (Number(currentFormPosition) + 1)) {
							if (element.hasClass("d-none")) {
								currentFormPosition = Number(currentFormPosition) + 1
							} else {
								element.addClass('active');
								me.updateGridPickers(element)
							}
						}
					});

					me.buildConfData()
					me.scrollFormToTop()
				}

				if (me.savePages) {
					me.saveCurrentPage(callback)
				} else {
					callback()
				}
			}
		});

		jQuery(this.formElementId).delegate(".confirmation-button", "click", (event) => {
			event.preventDefault();

			if (me.checkForm()) {
				jQuery(`${me.formElementId} .confirmation-page.firehawk-crm-form-modal`).modal({
					fadeDuration: 250
				})

				me.buildConfData()
			}
		});

		jQuery(this.formElementId).delegate('.confirmation-field-api-value', 'change', (event) => {
			console.log("changed value of api val", event)
		});

		jQuery(this.formElementId).delegate(".file-input-value  .btn", "click", function (event) {
			event.stopPropagation();
		});

		jQuery(this.formElementId).delegate(".file-input-value", "click", function (event) {
			event.preventDefault();

			var sel = getSelection().toString();
			if (!sel) {
				jQuery(this).siblings(".custom-file-input").click();
			}
		});

		jQuery(this.formElementId).delegate(".cancel-button", "click", (event) => {
			event.preventDefault();

			Swal.fire({
				title: 'Are you sure?',
				text: 'You can not undo this action',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes'
			}).then((result) => {
				if (result.value) {
					if (me.cancelRedirectTo && me.cancelRedirectTo.length) {
						window.location = me.cancelRedirectTo;
					} else {
						location.reload();
					}
				}
			})
		});

		jQuery(this.formElementId).delegate(".firehawk-crm-form-package-picker .plan-action .btn", "click", function (event) {
			let packageId = jQuery(this).data("package");
			let field = jQuery(this).parents(".firehawk-crm-form-package-picker")
			var fieldKey = field.attr('name');
			let addToCart = field.data("cart-item") == true || field.data("cart-item") == "true";

			if (fieldKey) {
				if (addToCart) {
					me.updateCart(fieldKey, packageId, 1)
				}

				me.selectedPackages[fieldKey] = packageId
				var currentForm = jQuery(me.formElementId);
				currentForm.find(".firehawk-crm-form-page.active form .next-button").click()

				if (me.packages && me.packages.length) {
					let packageOption = me.packages.filter(p => p.id == packageId)[0]

					var refreshGrids = []
					if (packageOption) {
						let gridIds = Object.keys(me.grids)
						for (let gridId of gridIds) {
							let grid = me.grids[gridId]
							if (grid && grid.packageUpgrade && grid.packageUpgradeTag && packageOption.ingredients && packageOption.ingredients.length) {
								let ingredient = packageOption.ingredients.filter(i => i.tags && i.tags.includes(grid.packageUpgradeTag))[0]
								grid.packageUpgradeBaseItem = ingredient
								grid.removeValue()
								refreshGrids.push(gridId)
							}
						}

						if (packageOption.formValues) {
							for (let value of packageOption.formValues) {
								var newValue = null
								if (value.type == "ingredient") {
									if (packageOption.ingredients && packageOption.ingredients.length && value.ingredientTag) {
										let ingredient = packageOption.ingredients.filter(i => i.tags && i.tags.includes(value.ingredientTag))[0]
										if (ingredient && ingredient.id) {
											newValue = ingredient.id
										}
									}
								} else if (value.value) {
									newValue = value.value
								}

								var fieldKey = jQuery(currentForm).find('[name=' + value.field + ']');

								if (me.grids && me.grids[value.field] && value.fieldTagFilters) {
									let fieldTerms = me.grids[value.field].customArrayTerms || []
									fieldTerms = fieldTerms.filter(f => f["tags"] == null)
									fieldTerms.push({ tags: value.fieldTagFilters })
									me.grids[value.field].customArrayTerms = fieldTerms
									if (!refreshGrids.filter(g => g == value.field)) {
										refreshGrids.push(value.field)
									}
								}
								me.setFieldValue(fieldKey, newValue)
							}
						}

						for (let gridId of refreshGrids) {
							let grid = me.grids[gridId]
							grid.refresh()
						}
					}
				}

				me.updatePackagePricingInfo()
			}
		})

		jQuery(this.formElementId).delegate(".tag-picker .tag", "click", function (event) {
			if (jQuery(this).hasClass("selected")) {
				jQuery(this).removeClass("selected")
			} else {
				jQuery(this).addClass("selected")
			}

			me.updateSelectedTagCounts()
			me.debounceChangeCheckForm()
		})

		jQuery(this.formElementId).delegate(".tag-picker .tag", "keydown", function (event) {
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code != 13) return;
			if (jQuery(this).hasClass("selected")) {
				jQuery(this).removeClass("selected")
			} else {
				jQuery(this).addClass("selected")
			}

			me.updateSelectedTagCounts()
			me.debounceChangeCheckForm()
		})

		jQuery(`${this.formElementId} .tag-picker .tag-group .tags`).on('hide.bs.collapse', function (event) {
			const collapseElement = jQuery(this)
			setTimeout(function () {
				collapseElement.parents(".tag-picker-col").removeClass("open")
			}, 200)
		})

		jQuery(`${this.formElementId} .tag-picker .tag-group .tags`).on('show.bs.collapse', function (event) {
			jQuery(this).parents(".tag-picker-col").addClass("open")
		})

		let tooltipTriggerList = [].slice.call(document.querySelectorAll(`${this.formElementId} [data-bs-toggle="tooltip"]`))
		let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl)
		})

		jQuery(this.formElementId).delegate(".save-btn", "click", function (event) {
			event.preventDefault();
			const eventTarget = jQuery(this);

			const buttonId = eventTarget.attr('id')
			const submitType = buttonId == "save-draft" ? "draft" : "save"

			if (me.isSavingForm) {
				return
			}

			me.showSaving(true);

			var extraData = {};
			if (eventTarget.data("extra-params")) {
				extraData = eventTarget.data("extra-params")
			}

			if (me.checkForm()) {
				var currentForm = jQuery(me.formElementId)
				var formSaveApiPath = eventTarget.data('api-url')
				var formSuccessMessage = eventTarget.data('success-message')
				var formSuccessTitle = eventTarget.data('success-title')
				var formSuccessConfirmButtonText = eventTarget.data('success-confirm-button-text')
				var ignoreSuccessModal = eventTarget.data('no-success-modal')

				var formData = new FormData()

				currentForm.find("form").each(function () {
					var pageFormData = new FormData(jQuery(this).get(0))
					pageFormData.forEach(function (value, key) {
						formData.append(key, value)
					})
				})

				jQuery(`${me.formElementId} .tag-picker`).each(function (index) {
					var values = []
					var fieldName = jQuery(this).attr('name');
					if (!fieldName) return

					jQuery(this).find(".tag.selected").each(function () {
						var value = jQuery(this).data("value")
						if (value) {
							values.push(value)
							formData.append(fieldName + '[]', value)
						}
					})
				})

				jQuery(`${me.formElementId} .time-picker-dropdown`).each(function (index) {
					var values = []
					var fieldName = jQuery(this).attr('name');
					if (!fieldName) return
					var value = jQuery(this).simpleTimePicker("getTime");
					formData.append(fieldName, value)
				})

				if (me.existingType && me.existingType.length) {
					formData.append("existingType", me.existingType);
				}

				if (me.entityId && me.entityId.length) {
					formData.append("paramValue", me.entityId);
				} else if (me.paramValue && me.paramValue.length) {
					formData.append("paramValue", me.paramValue);
				}

				if (me.formTemplate && me.formTemplate.length) {
					formData.append("formTemplate", me.formTemplate);
				}

				me.gridPickerValues().forEach(function (item, index) {
					formData.append(item.id, item.value)
				})

				for (let key in me.selectedPackages) {
					formData.append(key, me.selectedPackages[key])
				}

				me.addressPickerValues().forEach(function (item, index) {
					formData = me.appendFormArray(formData, {
						[item.id]: [item.value]
					})
				})

				jQuery.each(jQuery(currentForm).data(), function (i, v) {
					if (i.startsWith("apiParam")) {
						var valueArray = v.split(":");
						if (valueArray && valueArray.length == 2) {
							var paramKey = valueArray[0] || null;
							var paramValue = valueArray[1] || null;
							if (paramValue) {
								if (paramValue.startsWith("{")) {
									paramValue = paramValue.replace(/{/g, "")
									paramValue = paramValue.replace(/}/g, "")
									paramValue = paramValue.trim();
									if (paramValue == "team.id" && team) {
										formData.append(paramKey, fcrm_options.team)
									} else if (paramValue == "user.id") {
										// do nothing
									} else if (paramValue.startsWith("user.")) {
										var field = paramValue.slice(5);
										if (fcrm_options && fcrm_options.user && (fcrm_options.user["user_id"] == 0 || fcrm_options.user["user_id"])) {
											formData.append("wp_user_id", fieldValue);
										}
										if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
											var fieldValue = fcrm_options.user[field];
											formData.append(paramKey, fieldValue);
										}
									} else if (paramValue.startsWith("self.")) {
										var field = paramValue.slice(5);
										var fieldValue = jQuery(currentForm).find('[name=' + field + ']').val();
										formData.append(paramKey, fieldValue);
									}
								} else {
									if (paramValue == "true") paramValue = true;
									if (paramValue == "false") paramValue = false;
									formData.append(paramKey, paramValue);
								}
							}
						}
					}
				});

				if (!formSaveApiPath || !formSaveApiPath.length) {
					return;
				}

				if (formSaveApiPath && formSaveApiPath.startsWith("/")) {
					formSaveApiPath = formSaveApiPath.slice(1);
				}

				// var newFormData = new FormData();
				const newFormData = me.formatData(formData)
				// for ( var key in formattedData) {
				//     newFormData.append(key, formattedData[key]);
				// }

				for (var key in extraData) {
					newFormData.set(key, extraData[key])
				}

				for (var key in this.extraFormData) {
					newFormData.append(key, this.extraFormData[key])
				}

				let cartItemKeys = Object.keys(me.cartItems)

				let cartItems = []

				for (let fieldId of cartItemKeys) {
					let cartItem = me.cartItems[fieldId]
					if (cartItem.stock && cartItem.quantity) {
						cartItems.push(cartItem)
					}
				}

				for (let i in cartItems) {
					let index = +i
					let cartItem = cartItems[index]
					for (let key in cartItem) {
						newFormData.append(`cartItems[${i}][${key}]`, cartItem[key])
					}
				}

				if (Array.isArray(me.mandatoryCartItems) && me.mandatoryCartItems.length) {

					me.mandatoryCartItems.forEach((item, i) => {
						if (item.product_id) {
							item.stock = item.product_id
							delete item.product_id
						}

						for (let key in item) {
							newFormData.append(`mandatoryCartItems[${i}][${key}]`, item[key])
						}

					});
				}

				var uploadingFiles = currentForm.find('.form-element input[type="file"].uploading').length > 0
				if (uploadingFiles) {
					Swal.fire({
						title: 'Upload in progress',
						text: 'Please wait until all files have uploaded before continuing'
					})

					me.showSaving(false);
					return
				}

				newFormData.append('action', 'form_submit');
				newFormData.append('team', fcrm_options.team);
				newFormData.append("formId", me.formId);
				newFormData.append('url', formSaveApiPath);
				newFormData.append('security', ajax_var.nonce);

				jQuery.ajax({
					type: "POST",
					url: ajax_var.url,
					data: newFormData,
					processData: false,
					contentType: false,
					dataType: 'json',
				}).done((response) => {
					let success = response?.success == true;
					let result = response?.data
					if (!success || !result || !result.id || !result.id.length) {
						me.showSaving(false);
						Swal.fire({
							title: 'Oops...',
							text: 'Something went wrong!',
							icon: 'error',
							showCancelButton: true,
							confirmButtonColor: '#3085d6',
							confirmButtonText: 'Try again'
						}).then((result) => {
							if (result.value) {
								jQuery(`${me.formElementId} #submit`).click();
							}
						})
					} else {
						var extraParams = {}
						if (result.quoteId) extraParams.quoteId = result.quoteId

						me.onFormSuccessAddCart(result.id, result.contact, extraParams, formSuccessMessage, formSuccessTitle, formSuccessConfirmButtonText, ignoreSuccessModal, (success, error) => {
							console.log(success, error)
						})
					}

				}).fail(function (xhr, status, error) {
					console.error("Error", error)

					me.showSaving(false);

					Swal.fire({
						title: 'Oops...',
						text: 'Something went wrong!',
						icon: 'error',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						confirmButtonText: 'Try again'
					}).then((result) => {
						if (result.value) {
							jQuery(`${me.formElementId} #submit`).click();
						}
					})
				}).always(function () {

				});
			} else {
				me.showSaving(false);
			}
		})

		this.checkRelations();
		this.checkActivePageBlocked()
		this.checkPageRelations()
		this.updateSelectedTagCounts()
		this.updatePageWizard()
	}

	goBackPage() {
		this.checkPageRelations()
		this.toggleNextButton(true);
		var currentForm = jQuery(`${this.formElementId} .firehawk-crm-form-page.active`);
		var currentFormPosition = jQuery(currentForm).data('index');
		jQuery(currentForm).removeClass('active');

		jQuery(jQuery(`${this.formElementId} .firehawk-crm-form-page`).get().reverse()).each(function () {
			var element = jQuery(this)
			var formPosition = element.attr('data-index');

			if (Number(formPosition) == (Number(currentFormPosition) - 1)) {
				if (element.hasClass("d-none")) {
					currentFormPosition = Number(currentFormPosition) - 1
				} else {
					element.addClass('active');
					// jQuery('html,body').scrollTop(0);
				}
			}
		});
		this.checkRelations()
		this.checkActivePageBlocked()
		this.checkMergeLabels()
		this.updatePageWizard()
		this.scrollFormToTop()
	}

	scrollFormToTop() {
		var formElement = jQuery(this.formElementId)[0];
		var yOffset = this.scrollFormTopOffset || 0

		var offsetElement = null
		if (this.scrollFormOffsetElement) offsetElement = jQuery(this.scrollFormOffsetElement)[0]
		if (offsetElement) {
			yOffset = -offsetElement.getBoundingClientRect().height
		}

		const y = formElement.getBoundingClientRect().top + window.scrollY + yOffset;
		window.scrollTo({ top: y, behavior: "smooth" });
	}

	getCompleteFormData() {
		var me = this;
		var currentForm = jQuery(me.formElementId)

		var formData = new FormData()

		currentForm.find("form").each(function () {
			var pageFormData = new FormData(jQuery(this).get(0))
			pageFormData.forEach(function (value, key) {
				formData.append(key, value)
			})
		})

		formData.append('team', fcrm_options.team)

		jQuery(`${me.formElementId} .tag-picker`).each(function (index) {
			var values = []
			var fieldName = jQuery(this).attr('name');
			if (!fieldName) return

			jQuery(this).find(".tag.selected").each(function () {
				var value = jQuery(this).data("value")
				if (value) {
					values.push(value)
					formData.append(fieldName + '[]', value)
				}
			})
		})

		jQuery(`${me.formElementId} .time-picker-dropdown`).each(function (index) {
			var values = []
			var fieldName = jQuery(this).attr('name');
			if (!fieldName) return
			var value = jQuery(this).simpleTimePicker("getTime");
			formData.append(fieldName, value)
		})

		if (me.existingType && me.existingType.length) {
			formData.append("existingType", me.existingType);
		}

		if (me.entityId && me.entityId.length) {
			formData.append("paramValue", me.entityId);
		} else if (me.paramValue && me.paramValue.length) {
			formData.append("paramValue", me.paramValue);
		}

		if (me.formTemplate && me.formTemplate.length) {
			formData.append("formTemplate", me.formTemplate);
		}

		me.gridPickerValues().forEach(function (item, index) {
			formData.append(item.id, item.value)
		})

		for (let key in me.selectedPackages) {
			formData.append(key, me.selectedPackages[key])
		}

		me.addressPickerValues().forEach(function (item, index) {
			formData = me.appendFormArray(formData, {
				[item.id]: [item.value]
			})
		})

		const newFormData = me.formatData(formData)
		return newFormData
	}

	buildConfirmationRedirectURL() {
		if (!this.confirmationRedirectTo || !this.confirmationRedirectTo.length) {
			return
		}

		let newURL = null
		if (this.confirmationRedirectTo.startsWith("http")) {
			newURL = new URL(this.confirmationRedirectTo)
		} else {
			newURL = new URL(window.location)
			newURL.pathname = this.confirmationRedirectTo
		}

		newURL.search = "";

		if (this.redirectWithCart && this.cartId) {

			newURL.searchParams.append("cart", this.cartId)
		}

		return newURL.toString()
	}

	onFormSuccessAddCart(entityId, contact, extraParams, successMessage, successTitle, successButton, noSuccessModal, callback, noRedirect = false) {
		this.addItemsToCart(entityId, contact, extraParams, (success, error) => {
			if (success) {
				if (callback) callback(true, null)
				if(noRedirect) return;
				
				if (noSuccessModal == true) {
					if (this.confirmationRedirectTo && this.confirmationRedirectTo.length) {
						window.location = this.buildConfirmationRedirectURL()
					} else {
						location.reload();
					}
				} else {
					this.showSaving(false);

					var alertTitle = successTitle || successMessage || 'Successfully Saved'
					var alertMessage = successTitle == null ? "" : successMessage
					Swal.fire({
						title: alertTitle,
						html: alertMessage,
						icon: 'success',
						showCancelButton: false,
						confirmButtonColor: '#3085d6',
						confirmButtonText: successButton || 'Finish',
						allowOutsideClick: false
					}).then((result) => {
						if (result.value) {
							if (this.confirmationRedirectTo && this.confirmationRedirectTo.length) {
								window.location = this.buildConfirmationRedirectURL()
							} else {
								location.reload();
							}
						}
					})
				}
			} else {
				if (callback) callback(false, error)
				this.showSaving(false);
			
				Swal.fire({
					title: 'Oops...',
					text: 'Something went wrong!',
					icon: 'error',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Try again'
				}).then((result) => {
					if (result.value) {
						this.onFormSuccessAddCart(entityId, contact, extraParams, successMessage, successTitle, successButton, noSuccessModal, callback, noRedirect)
					}
				})
			}
		})
	}

	configureGoogleSearch() {
		if (!fcrm_options.useGoogleMapsApi) {
			return;
		}

		if (typeof google === "undefined" || typeof google.maps == "undefined" || typeof google.maps.places == "undefined") {
			return
		}
		var me = this

		jQuery(`${this.formElementId} .form-element[data-gaddressacfield]`).each(function (index) {
			var element = jQuery(this)
			var groupItem = element
			var gField = element.data("gaddressacfield")
			var groupKey = element.data("groupkey")

			if (gField && gField.length) {
				var elements = element.find(".form-element [id='" + gField + "']");
				for (var i = 0; i < elements.length; i++) {
					var addressAutoComplete = new google.maps.places.Autocomplete(elements[i]);
					addressAutoComplete.setComponentRestrictions({
						'country': ["AU"]
					})
					var googleListener = addressAutoComplete.addListener('place_changed', function () {
						var place = addressAutoComplete.getPlace()

						var addressComponents = place["address_components"] || {}

						var city = me.findGoogleAddressPart(addressComponents, ['locality', 'postal_town'], 'long_name') || ""
						var stateShort = me.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'short_name') || ""
						var stateLong = me.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'long_name') || ""
						var postcode = me.findGoogleAddressPart(addressComponents, 'postal_code', 'long_name') || ""
						var country = me.findGoogleAddressPart(addressComponents, 'country', 'long_name') || ""

						jQuery(groupItem).find("input[id='city']").val(city)
						var groupItemkey = groupKey
						if (jQuery(groupItem).data("groupkey")) {
							groupItemkey = jQuery(groupItem).data("groupkey")
							groupItemkey = groupItemkey.replace(/[\[\]()]/g, "-");
						}

						var statePicker = jQuery('[name="' + groupItemkey + '[0][state]"]');
						if (statePicker.length > 0 && statePicker.is('select')) {
							jQuery(statePicker).val(stateLong)
							if (jQuery(statePicker).data("select2")) {
								jQuery(statePicker).select2("data", {
									id: stateLong,
									text: stateShort
								})
								jQuery(statePicker).trigger('change')
							}
						} else {
							me.updateSegmentValue(groupItemkey + "-state", stateLong)
						}

						jQuery(groupItem).find("input[id='postcode']").val(postcode);
						jQuery(groupItem).find("select[id='country']").val(country);

						var subpremise = me.findGoogleAddressPart(addressComponents, 'subpremise', 'long_name') || ""
						var streetNumber = me.findGoogleAddressPart(addressComponents, 'street_number', 'long_name') || ""
						var street = me.findGoogleAddressPart(addressComponents, 'route', 'long_name') || ""

						var fullStreetNumber;
						if (subpremise && streetNumber) {
							fullStreetNumber = `${subpremise}/${streetNumber}`
						} else if (streetNumber) {
							fullStreetNumber = streetNumber
						}

						var line1 = "";

						if (fullStreetNumber && street) {
							line1 = `${fullStreetNumber} ${street}`
						} else if (street) {
							line1 = street
						}
						jQuery(groupItem).find("input[id='line1']").val(line1)
					})
				}
			}
		});
	}

	toggleNextButton(show = false, formPage = null) {
		var hideAction = (show, form) => {
			var nextButton = null
			if (form.find(".next-button").length) {
				nextButton = form.find(".next-button")
			} else if (form.find(".conf-next-button").length) {
				nextButton = form.find(".conf-next-button")
			} else if (form.find(".save-btn").length) {
				nextButton = form.find(".save-btn")
			}

			if (show) {
				form.removeClass("hide-next-btn")
			} else {
				form.addClass("hide-next-btn")
			}

			if (nextButton) {
				if (show) nextButton.show();
				if (!show) nextButton.hide()
			}
		}

		var activeFormPage = jQuery(`${this.formElementId} .firehawk-crm-form-page.active`);
		hideAction(show, formPage || activeFormPage)
	}

	toggleBackButton(show = false) {
		var currentForm = jQuery(this.formElementId);
		var backButton = null
		if (currentForm.find(".back-button").length) {
			backButton = currentForm.find(".back-button")
		} else if (currentForm.find(".conf-back-button").length) {
			backButton = currentForm.find(".conf-back-button")
		}
		if(backButton) {
			if(show) backButton.show();
			if(!show) backButton.hide()
		}

		this.backHidden = !show
	}

	getFormDataObject() {
		var me = this
		var currentForm = jQuery(me.formElementId)
		var formData = new FormData()

		currentForm.find("form").each(function () {
			var pageFormData = new FormData(jQuery(this).get(0))
			pageFormData.forEach(function (value, key) {
				formData.append(key, value)
			})
		})

		var object = {}
		formData.forEach((value, key) => {
			if (!Reflect.has(object, key)) {
				object[key] = value
				return
			}
			if (!Array.isArray(object[key])) {
				object[key] = [object[key]]
			}
			object[key].push(value)
		})

		return object
	}

	checkMergeLabels() {
		var me = this
		var currentForm = jQuery(me.formElementId)
		var formData = new FormData()
		currentForm.find("form").each(function () {
			var pageFormData = new FormData(jQuery(this).get(0))
			pageFormData.forEach(function (value, key) {
				formData.append(key, value)
			})

			jQuery(this).find(`.form-element:not(.d-none) .firehawk-crm-form-address-picker`).each(function(index) {
				const elementId = jQuery(this).attr('name')
				const picker = me.addressPickers[elementId]
				if (picker && picker.selectedAddress && picker.selectedAddress.full) {
					formData.append(elementId, picker.selectedAddress.full)
				}
			});
		})

		var object = {};
		formData.forEach((value, key) => {
			if (!Reflect.has(object, key)) {
				object[key] = value;
				return;
			}
			if (!Array.isArray(object[key])) {
				object[key] = [object[key]];
			}
			object[key].push(value);
		});

		jQuery(`${this.formElementId} .control-label[data-merge-name], ${this.formElementId} .form-title[data-merge-name], ${this.formElementId} .form-subtitle[data-merge-name], ${this.formElementId} .checkbox-label[data-merge-name], ${this.formElementId} .fh-p-content[data-merge-name], ${this.formElementId} h6[data-merge-name]`).each(function (index) {
			var element = jQuery(this)
			var originalName = element.data("name")
			var mergeName = element.data("merge-name")
			var merged = me.mergeLabelTags(mergeName, object, true)
			element.find(".content").html(merged || originalName || '')
		})
	}

	mergeLabelTags(content, data, ignoreNoValue) {
		var newContent = content
		let tags = newContent.match(/\[]*\[.*?\]\]/g);
		var ignoreValue = false

		if (tags && tags.length > 0) {
			tags.forEach(tag => {
				let replaced = tag.replace(/[\[\]']+/g, '')
				let pluralised = false;
				let isTeamData = false;

				if (replaced && replaced.includes(":")) {
					let splitReplaced = replaced.split(":")
					replaced = splitReplaced[0]
					if(replaced == "team" && splitReplaced[1] && splitReplaced[1].length) {
						isTeamData = true;
						replaced = splitReplaced[1]
						if(splitReplaced[2] && splitReplaced[2] == "plural") {
							pluralised = true;
						}
					} else if(splitReplaced[1] && splitReplaced[1] == "plural") {
						pluralised = true;
					}
				}

				if (ignoreNoValue && (!data || !data[replaced]) && !isTeamData) {
					ignoreValue = true
				}
				if(isTeamData && this.teamData) {
					let replaceData = this.teamData[replaced] || '';
					if(pluralised && replaceData && replaceData.length) {
						if(replaceData.endsWith("s")) {
							replaceData = replaceData + "'"
						} else {
							replaceData = replaceData + "'s"
						}
					}
					newContent = newContent.replace(tag, replaceData)
				} else if (data) {
					let replaceData = data[replaced] || '';
					if(pluralised && replaceData && replaceData.length) {
						if(replaceData.endsWith("s")) {
							replaceData = replaceData + "'"
						} else {
							replaceData = replaceData + "'s"
						}
					}
					newContent = newContent.replace(tag, replaceData)
				} else {
					newContent = newContent.replace(tag, '')
				}
			})
		}

		return ignoreValue ? null : newContent
	}

	updatePageHtmlDocuments() {
		let me = this;
		var currentForm = jQuery(`${this.formElementId} .firehawk-crm-form-page.active`);
		var objects = []

		if (this.quoteId && this.quoteId.length) {
			objects.push({
				key: this.quoteId,
				route: "quotes/list/",
				tag: "quote"
			})
		}

		if (this.entityType == "client" && this.entityId) {
			objects.push({
				key: this.entityId,
				route: "clients/list/",
				tag: "client"
			})
		}

		if (Array.isArray(this.mandatoryCartItems) && this.mandatoryCartItems.length) {
			this.mandatoryCartItems.forEach((item, i) => {
				if (item.product_id && item.key) {
					objects.push({
						key: item.product_id,
						route: "stock/list/",
						tag: item.key
					})
				}
			});
		}

		for (let key in this.selectedPackages) {
			let selectedPackage = this.selectedPackages[key]
			objects.push({
				key: selectedPackage,
				route: "stock/list/",
				tag: key
			})
		}

		jQuery(`${this.formElementId} .form-control[data-default-add-cart]`).each(function () {
			var fieldKey = jQuery(this).attr('name');
			var value = jQuery(this).val()
			if (jQuery(this).parents(".form-element").first().hasClass("d-none") == false && value != null && fieldKey) {
				objects.push({
					key: value,
					route: "stock/list/",
					tag: fieldKey
				})
			}
		})

		for (let key in this.grids) {
			let picker = this.grids[key]

			if (picker) {
				if (picker.multiselect) {
					objects.push({
						key: picker.selectedItems.map(s => s.id).filter(id => id),
						route: picker.searchRoute || "stock/list/",
						tag: key,
						isArray: true
					})
				} else {
					if (picker.selectedItem && picker.selectedItem.id) {
						objects.push({
							key: picker.selectedItem.id,
							route: picker.searchRoute || "stock/list/",
							tag: key
						})
					}
				}
			}
		}

		currentForm.find(".firehawk-crm-form-html-doc").each(function (index) {
			var id = jQuery(this).attr('name')
			if (id && me.htmlDocs[id]) {
				let firehawkDoc = me.htmlDocs[id]
				firehawkDoc.objects = objects

				if (firehawkDoc.container && firehawkDoc.container.data("extra-params")) {
					try {
						var compiledParams = {}
						let params = firehawkDoc.container.data("extra-params")
						let fieldKeys = Object.keys(params)

						let formData = me.getCompleteFormData()
						var object = {};
						formData.forEach(function(value, key){
							object[key] = value;
						});
						var json = JSON.stringify(object);
						var parsedData = JSON.parse(json)
						var mergeDataKeys = Object.keys(parsedData)
						var mergeData = {}

						// Format keys to be . delimited
						for (let key of mergeDataKeys) {
							const regex = /\[|\]/gi;
							let newKey = key.replaceAll("]", "").replaceAll("[", ".")
							mergeData[newKey] = parsedData[key]
						}

						// Merge extra params
						for (let key of fieldKeys) {
							let field = params[key]
							let value = me.mergeTags(field, mergeData, true)
							if (value != null) {
								compiledParams[key] = value
							}
						}

						firehawkDoc.extraParams = compiledParams
					} catch(error) {
						console.error(error)
						firehawkDoc.extraParams = {}
					}

				}
				firehawkDoc.refresh()
			}
		})
	}

	updatePackagePricingInfo() {
		if (!this.showPackagePricing) return
		let me = this;
		let pricingView = jQuery(`${me.formElementId} .firehawk-crm-form-package-info`)

		let price = 0
		let packageName = ""

		for (let key in this.selectedPackages) {
			let selectedPackage = this.selectedPackages[key]
			let packageOption = me.packages.filter(p => p.id == selectedPackage)[0]
			packageName = packageOption && packageOption.name

			if (packageOption && packageOption.totalPrice) {
				price += +packageOption.totalPrice
			}
		}

		for (let key in this.grids) {
			let picker = this.grids[key]
			if (picker && picker.searchIndex == "stock") {
				if (picker.multiselect) {
					for (let item of picker.selectedItems) {
						let itemPrice = picker.calculatePriceForItem(item)
						price += +itemPrice
					}
				} else if (picker.selectedItem && picker.selectedItem.id) {
					let itemPrice = picker.calculatePriceForItem(picker.selectedItem)
					price += +itemPrice
				}
			}
		}

		var currencySymbol = this.currencySymbol || "$"

		pricingView.find(".plan-name").html(packageName)

		if (this.updateExternalPlanNameClasses) {
			jQuery(this.updateExternalPlanNameClasses).html(packageName)
		}

		var priceValues = ` ${currencySymbol}${price}`

		if (this.mandatoryPackageItems && this.mandatoryPackageItems.length) {
			let extraItems = this.mandatoryPackageItems.map((s) => {
				if (!s.priceFormatted) return null
				return `${s.priceFormatted} ${s.name}`
			}).filter(s => s)

			if (extraItems.length) {
				priceValues += " + " + extraItems.join(" + ")
			}
		}

		pricingView.find(".plan-price").html(priceValues)
	}

	updatePageWizard() {
		let me = this;

		var currentForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`);
		var formWizard = jQuery(`${me.formElementId} .firehawk-crm-form-wizard`);

		var activePagId = currentForm.data("page-id")

		var activeIndex = 0
		jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item:not(.d-none)`).each(function (index) {
			if (jQuery(this).data("page-id") == activePagId) {
				jQuery(this).addClass("active")
				activeIndex = index
			} else {
				jQuery(this).removeClass("active")
			}
		})

		jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item:not(.d-none)`).each(function (index) {
			if (!jQuery(this).hasClass("active") && index < activeIndex) {
				jQuery(this).addClass("complete")
			} else {
				jQuery(this).removeClass("complete")
			}
		})

		let offset = jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item.active`).offset()
		if (offset) {
			jQuery(`${this.formElementId} .firehawk-crm-form-wizard`).animate({
				scrollLeft: jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item.active`).offset().left
			}, 500);
		}

		if (currentForm.hasClass("hide-wizard")) {
			formWizard.addClass("d-none")
		} else {
			formWizard.removeClass("d-none")
		}
	}

	updatePageWizardNumbers() {
		let me = this;

		var currentIndex = 1
		jQuery(`${this.formElementId} .firehawk-crm-form-wizard .wizard-item`).each(function (index) {
			if (jQuery(this).hasClass("d-none")) {

			} else {
				jQuery(this).find(".page-number").html(currentIndex)
				currentIndex += 1
			}
		})
	}


	checkPageRelations() {
		let me = this;

		jQuery(`${this.formElementId} .firehawk-crm-form-page[data-relation]`).each(function (index) {
			var element = jQuery(this)
			var pageId = element.data("page-id")
			var relationData = element.data("relation")
			var relationDataKeys = Object.keys(relationData);
			var confirmPage = null

			var formWizard = jQuery(`${me.formElementId} .firehawk-crm-form-wizard`);

			if (pageId && pageId.length) {
				confirmPage = jQuery(`${me.formElementId} .firehawk-crm-form-page.confirmation-page #confirm-page-${pageId}`)
			}

			for (var i = 0; i < relationDataKeys.length; i++) {
				var relData = relationData[relationDataKeys[i]]
				if (relData) {
					var action = relData['action'] || null;
					var connective = relData['connective'] || null;
					var when = relData['when'] || null;

					if (!action || !connective || !when) {
						continue;
					}

					var conditionsMet = false;

					conditionsMet = me.checkConnectiveRelation(relData, false, this, action)

					if (action && action.length) {
						switch (action.toLowerCase()) {
							case "show":
								if (conditionsMet) {
									element.removeClass('d-none');
									element.find(".form-element").removeClass("d-none")
									if (confirmPage) confirmPage.removeClass("d-none")

									if (pageId) {
										formWizard.find(`.wizard-item[data-page-id='${pageId}']`).removeClass("d-none")
										formWizard.find(`.bar-item[data-page-id='${pageId}']`).removeClass("d-none")
									}

								} else {
									element.find(".form-control").val(null)
									element.addClass('d-none');
									element.find(".form-element").addClass("d-none")

									if (pageId) {
										formWizard.find(`.wizard-item[data-page-id='${pageId}']`).addClass("d-none")
										formWizard.find(`.bar-item[data-page-id='${pageId}']`).addClass("d-none")
									}
									element.find(".firehawk-crm-form-address-picker").each(function () {
										var pickerId = jQuery(this).attr("name")
										if (pickerId && me.addressPickers[pickerId]) {
											me.addressPickers[pickerId].removeAddressInfo()
										}
									})

									element.find(".firehawk-crm-form-grid-picker").each(function () {
										var pickerId = jQuery(this).attr("id")
										if (pickerId && me.grids[pickerId]) {
											me.grids[pickerId].removeValue()
										}
									})

									element.find(".firehawk-crm-form-package-picker").each(function () {
										var pickerId = jQuery(this).attr("id")
										if (pickerId && me.selectedPackages[pickerId]) {
											me.removeFromCart(pickerId)
											delete me.selectedPackages[pickerId]
										}
									})

									if (confirmPage) confirmPage.addClass("d-none")
								}
								break;
							case "hide":
								if (conditionsMet) {
									element.find(".form-control").val(null)
									element.addClass('d-none');
									element.find(".form-element").addClass("d-none")

									if (pageId) {
										formWizard.find(`.wizard-item[data-page-id='${pageId}']`).addClass("d-none")
										formWizard.find(`.bar-item[data-page-id='${pageId}']`).addClass("d-none")
									}

									element.find(".firehawk-crm-form-address-picker").each(function () {
										var pickerId = jQuery(this).attr("name")
										if (pickerId && me.addressPickers[pickerId]) {
											me.addressPickers[pickerId].removeAddressInfo()
										}
									})

									element.find(".firehawk-crm-form-grid-picker").each(function () {
										var pickerId = jQuery(this).attr("id")
										if (pickerId && me.grids[pickerId]) {
											me.grids[pickerId].removeValue()
										}
									})

									element.find(".firehawk-crm-form-package-picker").each(function () {
										var pickerId = jQuery(this).attr("id")
										if (pickerId && me.selectedPackages[pickerId]) {
											me.removeFromCart(pickerId)
											delete me.selectedPackages[pickerId]
										}
									})

									if (confirmPage) confirmPage.addClass("d-none")
								} else {
									if (pageId) {
										formWizard.find(`.wizard-item[data-page-id='${pageId}']`).removeClass("d-none")
										formWizard.find(`.bar-item[data-page-id='${pageId}']`).removeClass("d-none")
									}
									element.removeClass('d-none');
									element.find(".form-element").removeClass("d-none")
									if (confirmPage) confirmPage.removeClass("d-none")
								}
								break;
							default:
								break;
						}
					}
				}
			}
		})

		this.updatePageWizardNumbers()
	}

	checkActivePageBlocked() {
		let me = this;
		var pageBlocked = false

		var currentForm = jQuery(`${me.formElementId} .firehawk-crm-form-page.active`);

		if (currentForm.hasClass('has-checkout')) {
			pageBlocked = true
		}

		jQuery(currentForm).find(".segment-button").each(function() {
			const eventTarget = jQuery(this);
			const hideNextButton = eventTarget.data("hide-next-button")
			const shouldHideNextButton = hideNextButton == true || hideNextButton == "true"

			if (eventTarget.find("input").is(':checked') && shouldHideNextButton) {
				pageBlocked = true
				me.toggleNextButton(false);
			}
		})

		jQuery(currentForm).find(".checkbox-list-item").each(function() {
			const eventTarget = jQuery(this);
			const hideNextButton = eventTarget.data("hide-next-button")
			const shouldHideNextButton = hideNextButton == true || hideNextButton == "true"

			if (eventTarget.find("input").is(':checked') && shouldHideNextButton) {
				pageBlocked = true
				me.toggleNextButton(false);
			}
		})

		var relationData = currentForm.data("relation")

		if (relationData) {
			var relationDataKeys = Object.keys(relationData);
			for (var i = 0; i < relationDataKeys.length; i++) {
				var relData = relationData[relationDataKeys[i]]
				if (relData) {
					var action = relData['action'] || null;
					var connective = relData['connective'] || null;
					var when = relData['when'] || null;

					if (!action || !connective || !when) {
						continue;
					}

					var conditionsMet = false;

					conditionsMet = me.checkConnectiveRelation(relData, false, currentForm, action)

					if (action && action.length) {
						switch (action.toLowerCase()) {
							case "block":
								if (conditionsMet) {
									pageBlocked = true
								}
								break;
							default:
								break;
						}
					}
				}
			}
		}

		var hideNextConditions = currentForm.data("hideNextConditions")
		if (hideNextConditions && Array.isArray(hideNextConditions)) {
			for (var i = 0; i < hideNextConditions.length; i++) {
				var conditionGroup = hideNextConditions[i]
				if (conditionGroup && conditionGroup.connective && conditionGroup.when) {
					var conditionMet = me.checkConnectiveRelation(conditionGroup, false, currentForm, "block")
					if (conditionMet) {
						pageBlocked = true
						break
					}
				}
			}
		}

		this.toggleNextButton(!pageBlocked, currentForm)
		
		return pageBlocked
	}

	checkPageBlockRelations() {
		let me = this;

		jQuery(`${this.formElementId} .firehawk-crm-form-page[data-relation]`).each(function (index) {
			var element = jQuery(this)
			var pageId = element.data("page-id")
			var relationData = element.data("relation")
			var relationDataKeys = Object.keys(relationData);
			
			for (var i = 0; i < relationDataKeys.length; i++) {
				var relData = relationData[relationDataKeys[i]]
				if (relData) {
					var action = relData['action'] || null;
					var connective = relData['connective'] || null;
					var when = relData['when'] || null;

					if (!action || !connective || !when) {
						continue;
					}

					var conditionsMet = false;

					conditionsMet = me.checkConnectiveRelation(relData, false, this, action)

					if (action && action.length) {
						switch (action.toLowerCase()) {
							case "block":
								me.toggleNextButton(!conditionsMet, element)
								break;
							default:
								break;
						}
					}
				}
			}
		})
	}

	triggerCheckRelations() {
		this.debounceCheckRelations()
	}

	checkRelations() {
		let me = this;

		jQuery(`${this.formElementId} .form-element[data-relation]`).each(function (index) {
			var element = jQuery(this)
			var fieldId = element.data("field-id")
			var relationData = element.data("relation")
			var parentKey = element.data("parent-key");
			var relationDataKeys = Object.keys(relationData);
			var maskFormat = element.data("maskFormat");

			for (var i = 0; i < relationDataKeys.length; i++) {
				var relData = relationData[relationDataKeys[i]]
				if (relData) {
					var action = relData['action'] || null;
					var connective = relData['connective'] || null;
					var when = relData['when'] || null;
					var useApi = relData['useApi'] || false;

					if (!action || !connective || !when) {
						continue;
					}

					var whenKeys = Object.keys(when);
					var conditionsMet = false;

					conditionsMet = me.checkConnectiveRelation(relData, useApi, this, action, parentKey)

					if (action && action.length && !useApi) {
						switch (action.toLowerCase()) {
							case "show":
								if (conditionsMet) {
									me.setDefaultValue(element)
									element.removeClass('d-none');
									jQuery(`.confirmation-field[data-field-id="${fieldId}"]`).removeClass("d-none")

									if (fieldId && me.grids[fieldId]) {
										me.grids[fieldId].updateLayout()
									}
								} else {
									element.find(".form-control").val(null)
									element.addClass('d-none');

									if (fieldId && me.addressPickers[fieldId]) {
										me.addressPickers[fieldId].removeAddressInfo()
									}

									if (fieldId && me.grids[fieldId]) {
										me.grids[fieldId].removeValue()
									}

									if (fieldId && me.selectedPackages[fieldId]) {
										me.removeFromCart(fieldId)
										delete me.selectedPackages[fieldId]
									}

									jQuery(`.confirmation-field[data-field-id="${fieldId}"]`).addClass("d-none")

									const segments = element.find(".segment-button")
									const multiple = segments.data("multiple")
									const segmentId = segments.data("segment-id")
									let hasMultiple = multiple === true || multiple === "true";
									me.updateSegmentValue(segmentId, null, fieldId, hasMultiple)
								}
								break;
							case "hide":
								if (conditionsMet) {
									element.find(".form-control").val(null)
									element.addClass('d-none');

									if (fieldId && me.addressPickers[fieldId]) {
										me.addressPickers[fieldId].removeAddressInfo()
									}

									if (fieldId && me.grids[fieldId]) {
										me.grids[fieldId].removeValue()
									}

									if (fieldId && me.selectedPackages[fieldId]) {
										me.removeFromCart(fieldId)
										delete me.selectedPackages[fieldId]
									}

									jQuery(`.confirmation-field[data-field-id="${fieldId}"]`).addClass("d-none")

									const segments = element.find(".segment-button")
									const multiple = segments.data("multiple")
									const segmentId = segments.data("segment-id")
									let hasMultiple = multiple === true || multiple === "true";
									me.updateSegmentValue(segmentId, null, fieldId, hasMultiple)
								} else {
									me.setDefaultValue(element)
									element.removeClass('d-none');
									jQuery(`.confirmation-field[data-field-id="${fieldId}"]`).removeClass("d-none")

									if (fieldId && me.grids[fieldId]) {
										me.grids[fieldId].updateLayout()
									}
								}
								break;
							case "copy":
								if (conditionsMet) {
									var control = element.find(".form-control")
									me.formCalculator.runCopyRelation(relData, control, maskFormat)
								} else {
									me.setDefaultValue(element)
								}
								break
							default:
								break;
						}
					}
				}
			}
		})

		jQuery(`${this.formElementId} .form-element[data-section]`).each(function (index) {
			var sectionData = jQuery(this).data("section")
			// console.log("sectionData", sectionData);
			var length = 0;
			jQuery('.form-element[data-sectionparent="' + sectionData + '"]:not(.d-none)').each(function () {
				length += 1;
			});
			// console.log("sectionData", sectionData, length);
			if (length == 0) {
				jQuery(this).addClass('d-none');
			} else {
				jQuery(this).removeClass('d-none');
			}
		});
	}

	uploadFileInput(fileInput) {
		let me = this;
		jQuery(fileInput).addClass("uploading")

		const apiPath = jQuery(fileInput).data("upload-url")

		var currentForm = jQuery(`${this.formElementId}`);

		var formData = new FormData();

		jQuery.each(jQuery(currentForm).data(), function (i, v) {
			if (i.startsWith("apiParam")) {
				var valueArray = v.split(":");
				if (valueArray && valueArray.length == 2) {
					var paramKey = valueArray[0] || null;
					var paramValue = valueArray[1] || null;
					if (paramValue) {
						if (paramValue.startsWith("{")) {
							paramValue = paramValue.replace(/{/g, "")
							paramValue = paramValue.replace(/}/g, "")
							paramValue = paramValue.trim();
							if (paramValue == "team.id" && team) {
								formData.append(paramKey, fcrm_options.team)
							} else if (paramValue == "user.id") {
								// do nothing
							} else if (paramValue.startsWith("user.")) {
								var field = paramValue.slice(5);
								if (fcrm_options && fcrm_options.user && (fcrm_options.user["user_id"] == 0 || fcrm_options.user["user_id"])) {
									formData.append("wp_user_id", fieldValue);
								}
								if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
									var fieldValue = fcrm_options.user[field];
									formData.append(paramKey, fieldValue);
								}
							} else if (paramValue.startsWith("self.")) {
								var field = paramValue.slice(5);
								var fieldValue = jQuery(currentForm).find('[name=' + field + ']').val();
								formData.append(paramKey, fieldValue);
							}
						} else {
							if (paramValue == "true") paramValue = true;
							if (paramValue == "false") paramValue = false;
							formData.append(paramKey, paramValue);
						}
					}
				}
			}
		});

		if (me.existingType && me.existingType.length) {
			formData.append("existingType", me.existingType);
		}

		if (me.entityId && me.entityId.length) {
			formData.append("paramValue", me.entityId);
		} else if (me.paramValue && me.paramValue.length) {
			formData.append("paramValue", me.paramValue);
		}

		if (me.formTemplate && me.formTemplate.length) {
			formData.append("formTemplate", me.formTemplate);
		}

		formData.append(jQuery(fileInput).attr("name"), jQuery(fileInput)[0].files[0]);

		formData.append('action', 'form_submit');
		formData.append('team', fcrm_options.team);
		formData.append("formId", me.formId);
		formData.append('url', apiPath);
		formData.append('security', ajax_var.nonce);

		jQuery.ajax({
			type: "POST",
			url: ajax_var.url,
			data: newFormData,
			processData: false,
			contentType: false,
			dataType: 'json',
		}).done(function(response) {
			let success = response?.success == true;
			let result = response?.data
			if (result && result.id) {
				me.entityId = result.id;
			}
			jQuery(fileInput).removeClass("changed")
		}).fail(function (xhr, status, error) {
			console.error("Error", error)
			Swal.fire({
				title: 'Oops...',
				text: 'Something went wrong!',
				icon: 'error',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'Try again'
			}).then((result) => {
				if (result.value) {
					me.uploadFileInput(fileInput)
				}
			})
		}).always(function () {
			jQuery(fileInput).removeClass("uploading")
		});
	}

	saveCurrentPage(callback) {
		var me = this
		var extraData = this.draftSaveParams

		var currentForm = jQuery(this.formElementId);
		var activeFormPage = currentForm.find(".firehawk-crm-form-page.active form")

		var nextButton = null
		if (currentForm.find(".next-button").length) {
			nextButton = currentForm.find(".next-button")
		} else if (currentForm.find(".conf-next-button").length) {
			nextButton = currentForm.find(".conf-next-button")
		}

		this.showSaving(true, nextButton);

		if (!activeFormPage.length) {
			this.showSaving(false, nextButton);
			return
		}

		if (!this.checkForm()) {
			this.showSaving(false, nextButton);
			return
		}

		var formSaveApiPath = currentForm.data("api-url")

		if (nextButton && nextButton.data("api-url") && nextButton.data("api-url").length) {
			formSaveApiPath = nextButton.data("api-url")
		}

		var formData = new FormData(activeFormPage.get(0))

		jQuery(`${this.formElementId} .tag-picker`).each(function () {
			var values = []
			var fieldName = jQuery(this).attr('name');
			if (!fieldName) return
			jQuery(this).find(".tag.selected").each(function () {
				var value = jQuery(this).data("value")
				if (value) {
					values.push(value)
					formData.append(fieldName + '[]', value)
				}
			})
		})

		if (me.existingType && me.existingType.length) {
			formData.append("existingType", me.existingType);
		}

		if (me.entityId && me.entityId.length) {
			formData.append("paramValue", me.entityId);
		} else if (me.paramValue && me.paramValue.length) {
			formData.append("paramValue", me.paramValue);
		}

		if (me.formTemplate && me.formTemplate.length) {
			formData.append("formTemplate", me.formTemplate);
		}

		me.gridPickerValues().forEach(function (item, index) {
			formData.append(item.id, item.value)
		})

		for (let key in me.selectedPackages) {
			formData.append(key, me.selectedPackages[key])
		}

		me.addressPickerValues().forEach(function (item, index) {
			formData = me.appendFormArray(formData, {
				[item.id]: [item.value]
			})
		})

		jQuery.each(jQuery(currentForm).data(), function (i, v) {
			if (i.startsWith("apiParam")) {
				var valueArray = v.split(":");
				if (valueArray && valueArray.length == 2) {
					var paramKey = valueArray[0] || null;
					var paramValue = valueArray[1] || null;
					if (paramValue) {
						if (paramValue.startsWith("{")) {
							paramValue = paramValue.replace(/{/g, "")
							paramValue = paramValue.replace(/}/g, "")
							paramValue = paramValue.trim();
							if (paramValue == "team.id" && team) {
								formData.append(paramKey, fcrm_options.team)
							} else if (paramValue == "user.id") {
								// do nothing
							} else if (paramValue.startsWith("user.")) {
								var field = paramValue.slice(5);
								if (fcrm_options && fcrm_options.user && (fcrm_options.user["user_id"] == 0 || fcrm_options.user["user_id"])) {
									formData.append("wp_user_id", fieldValue);
								}
								if (fcrm_options && fcrm_options.user && fcrm_options.user[field] && fcrm_options.user[field].length) {
									var fieldValue = fcrm_options.user[field];
									formData.append(paramKey, fieldValue);
								}
							} else if (paramValue.startsWith("self.")) {
								var field = paramValue.slice(5);
								var fieldValue = jQuery(currentForm).find('[name=' + field + ']').val();
								formData.append(paramKey, fieldValue);
							}
						} else {
							if (paramValue == "true") paramValue = true;
							if (paramValue == "false") paramValue = false;
							formData.append(paramKey, paramValue);
						}
					}
				}
			}
		});

		if (!formSaveApiPath || !formSaveApiPath.length) {
			return;
		}

		if (formSaveApiPath && formSaveApiPath.startsWith("/")) {
			formSaveApiPath = formSaveApiPath.slice(1);
		}

		const newFormData = this.formatData(formData, true)

		for (var key in extraData) {
			newFormData.set(key, extraData[key])
		}

		for (var key in this.extraFormData) {
			newFormData.append(key, this.extraFormData[key])
		}

		newFormData.append('action', 'form_submit');
		newFormData.append('team', fcrm_options.team);
		newFormData.append("formId", me.formId);
		newFormData.append('url', formSaveApiPath);
		newFormData.append('security', ajax_var.nonce);

		jQuery.ajax({
			type: "POST",
			url: ajax_var.url,
			data: newFormData,
			processData: false,
			contentType: false,
			dataType: 'json',
		}).done(function(response) {
			let success = response?.success == true;
			let result = response?.data
			if (!success || !result || !result.id || !result.id.length) {
				Swal.fire({
					title: 'Oops...',
					text: 'Something went wrong!',
					icon: 'error',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Try again'
				}).then((result) => {
					if (result.value) {
						if (nextButton) {
							nextButton.click()
						}
					}
				})
				return
			} else {
				me.entityId = result.id;
				jQuery(`${me.formElementId} .form-element input[type="file"]`).each(function () {
					jQuery(this).removeClass("changed")
				});

				callback()
			}
		}).fail(function (xhr, status, error) {
			console.error("Error", error)
			Swal.fire({
				title: 'Oops...',
				text: 'Something went wrong!',
				icon: 'error',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'Try again'
			}).then((result) => {
				if (result.value) {
					if (nextButton) {
						nextButton.click()
					}
				}
			})
		}).always(function () {
			me.showSaving(false, nextButton);
		});
	}

	updateSegmentValue(segmentId, segmentValue, fieldId, multiple = false) {
		if (!segmentId) return
		var $radios = jQuery(`.segment-${segmentId} input:checkbox`);

		if (fieldId) {
			$radios = jQuery(`.form-element[data-field-id="${fieldId}"]`).find(`.segment-${segmentId} input:checkbox`)
		}

		if (multiple) {
			var newSelection = $radios.filter(`[value="${segmentValue}"]`);
			if (jQuery(newSelection).is(':checked')) {
				jQuery(newSelection).prop("checked", false)
				jQuery(newSelection).parent().removeClass("btn-primary")
				jQuery(newSelection).parent().addClass("btn-light")
			} else {
				jQuery(newSelection).prop('checked', true);
				jQuery(newSelection).parent().removeClass("btn-light")
				jQuery(newSelection).parent().addClass("btn-primary")
			}

			// console.log("AAAAAA", currentSelection)
		} else {

			$radios.each(function (index) {
				if (jQuery(this).is(":checked") || jQuery(this).attr("checked") != null) {
					jQuery(this).removeAttr('checked')
					jQuery(this).prop('checked', false);
					jQuery(this).parent().removeClass("btn-primary").addClass("btn-light");
				}
			})
			var newSelection = $radios.filter(`[value="${segmentValue}"]`);
			jQuery(newSelection).prop("checked", true)
			jQuery(newSelection).parent().removeClass("btn-light")
			jQuery(newSelection).parent().addClass("btn-primary")
		}
	}

	updateCheckboxListValue(fieldId, fieldValue, multiple = false) {
		var $radios = jQuery(`.checkbox-list-item-${fieldId} input:checkbox`);

		if (multiple) {
			var newSelection = $radios.filter(`[value="${fieldValue}"]`);
			if (jQuery(newSelection).is(':checked')) {
				jQuery(newSelection).prop("checked", false)
				jQuery(newSelection).parent().removeClass("selected")
				const cartItem = jQuery(newSelection).data('cart-item');
				const cartItemAction = jQuery(newSelection).data('cart-item-action');
				if (cartItem && cartItemAction === "add") {
					this.removeFromCart(fieldId);
				}
			} else {
				jQuery(newSelection).prop('checked', true);
				jQuery(newSelection).parent().addClass("selected")
				const cartItem = jQuery(newSelection).data('cart-item');
				const cartItemAction = jQuery(newSelection).data('cart-item-action');
				if (cartItem && cartItemAction === "add") {
					this.updateCart(fieldId, cartItem, 1);
				}
			}
		} else {
			var newSelection = $radios.filter(`[value="${fieldValue}"]`);
			var previouslySelected = $radios.filter(":checked")

			if (jQuery(newSelection).is(':checked')) {
				$radios.each(function (index) {
					if (jQuery(this).is(":checked") || jQuery(this).attr("checked") != null) {
						jQuery(this).removeAttr('checked')
						jQuery(this).prop('checked', false);
						jQuery(this).parent().removeClass("selected")
					}
				})
				const cartItem = jQuery(newSelection).data('cart-item');
				const cartItemAction = jQuery(newSelection).data('cart-item-action');
				if (cartItem && cartItemAction === "add") {
					this.removeFromCart(fieldId);
				}
			} else {
				$radios.each(function (index) {
					if (jQuery(this).is(":checked") || jQuery(this).attr("checked") != null) {
						jQuery(this).removeAttr('checked')
						jQuery(this).prop('checked', false);
						jQuery(this).parent().removeClass("selected")
					}
				})

				var newSelection = $radios.filter(`[value="${fieldValue}"]`);
				jQuery(newSelection).prop("checked", true)
				jQuery(newSelection).parent().addClass("selected")
				const cartItem = jQuery(newSelection).data('cart-item');
				const cartItemAction = jQuery(newSelection).data('cart-item-action');

				if (cartItem && cartItemAction === "add") {
					this.updateCart(fieldId, cartItem, 1);
				} else {
					this.removeFromCart(fieldId);
				}
			}
		}
	}

	updateCart(fieldId, productId, quantity, extraParams = {}) {
		if (!productId || !productId.length || !fieldId || !fieldId.length || !quantity) return;

		this.cartItems[fieldId] = {
			...(extraParams || {}),
			stock: productId,
			quantity: quantity
		}
	}

	removeFromCart(fieldId) {
		if (fieldId && fieldId.length) {
			delete this.cartItems[fieldId];
		}
	}

	getDefaultCartItems() {
		var cartItems = this.cartItems || []
		var returnItems = []

		if (Array.isArray(this.mandatoryCartItems) && this.mandatoryCartItems.length) {
			this.mandatoryCartItems.forEach((item, i) => {
				if (item.product_id) {
					item.stock = item.product_id
					delete item.product_id
				}
				cartItems[`_mandatory_${i}`] = item;
			});
		}

		let cartItemKeys = Object.keys(cartItems)


		for (let fieldId of cartItemKeys) {
			let cartItem = cartItems[fieldId]
			if (cartItem.stock && cartItem.quantity) {
				returnItems.push(cartItem)
			}
		}

		jQuery(`${this.formElementId} .form-control[data-default-add-cart]`).each(function () {
			var fieldKey = jQuery(this).attr('name');
			var value = jQuery(this).val()
			if (jQuery(this).parents(".form-element").first().hasClass("d-none") == false && value != null && fieldKey) {
				returnItems.push({
					stock: value,
					quantity: 1
				})
			}
		})

		return returnItems
	}

	addItemsToCart(entityId, contact, extraParams, callback) {
		let me = this

		let cartItems = this.getDefaultCartItems()

		if (cartItems && cartItems.length) {
			var params = {
				...(extraParams || {}),
				items: cartItems,
				contact: contact
			}

			if (this.noShipping) {
				params.noShipping = true
			} else if (this.cartShippingMethods && this.cartShippingMethods.length) {
				params.shippingMethods = this.cartShippingMethods
			}

			if (this.attachPaymentToOrder == false) {
				params.attachPaymentToOrder = false
			}

			if (this.disablePaymentPlans) {
				params.disablePaymentPlans = true
			}

			if (entityId && this.entityType) {
				params[this.entityType] = entityId
			}

			jQuery.ajax({
				method: "POST",
				url: ajax_var.url,
				data: {
					action: 'replace_cart',
					params: params
				}
			}).done((response) => {
				var success = false

				if (response && response.result && response.result.cart) {
					success = true
					this.cartId = response.result.cart
				}

				callback(true, null);
			}).fail((xhr, status, error) => {
				console.error(error)
				callback(false, error);
			})
		} else {
			callback(true, null);
		}
	}

	addGroupedItemsToCart(cartItems, callback) {
		if (Array.isArray(cartItems) && cartItems.length) {
			let params = {
				items: cartItems
			}

			jQuery.ajax({
				method: "POST",
				url: ajax_var.url,
				data: {
					action: 'add_form_items_to_cart',
					params: params
				}
			}).done((response) => {
				var success = false
				if (response && response.result && response.result.cart) {
					success = true
				}
				callback(success, null)
			}).fail((xhr, status, error) => {
				console.error(error)
				callback(true, error)
			})
		} else {
			callback(true, null);
		}
	}

	addSingleItemToCart(cartItem, callback) {
		if (cartItem.stock && cartItem.quantity) {
			jQuery.ajax({
				method: "POST",
				url: ajax_var.url,
				data: {
					action: 'add_form_item_to_cart',
					params: cartItem
				}
			}).done((response) => {
				var success = false
				if (response && response.result && response.result.cart) {
					success = true
				}

				callback(success, null);
			}).fail((xhr, status, error) => {
				console.error(error)
				callback(false, error);
			})
		} else {
			callback(true, null);
		}
	}

	clearCart(callback) {
		jQuery.ajax({
			method: "POST",
			url: ajax_var.url,
			data: {
				action: 'clear_cart',
				params: {
					clear: true
				}
			}
		}).done((response) => {
			var success = false
			if (response && response.result && response.result.cart) {
				success = true
			}

			callback(success, null)
		}).fail((xhr, status, error) => {
			console.error(error)
			callback(false, error)
		})
	}

	prefillDataFromQuery(params) {
		jQuery('.form-element input:visible').each(function (index) {
			if (jQuery(this).attr('id')) {
				const queryValue = params.get(jQuery(this).attr('id'));
				if (queryValue) {
					jQuery(this).val(queryValue)
					jQuery(this).inputmask("setvalue", queryValue)
				}
			}
		});
	}

	showSaving(saving, button) {
		this.isSavingForm = saving
		jQuery(`${this.formElementId} .save-btn`).attr("disabled", saving);
		jQuery(`${this.formElementId} .back-button`).attr("disabled", saving);
		jQuery(`${this.formElementId} .next-button`).attr("disabled", saving);
		var saveButton = button || jQuery(`${this.formElementId} .save-btn`)

		if (saving) {
			saveButton.children('.spinner-border').removeClass('d-none');
		} else {
			saveButton.children('.spinner-border').addClass('d-none');
		}
	}

	buildGridPicker(id) {
		const gridElement = document.querySelector(`${this.formElementId} #${id}`)
		if (!gridElement) {
			return
		}

		const urlParams = new URLSearchParams(window.location.search);
		const queryValue = urlParams.get(id);

		let index = jQuery(gridElement).data("api-es-index") || null;
		let addToCart = jQuery(gridElement).data("cart-item") == true || jQuery(gridElement).data("cart-item") == "true";
		let showInWeb = jQuery(gridElement).data("api-es-only-show-in-web") || null;
		let route = jQuery(gridElement).data("api-es-route") || null;
		let layout = jQuery(gridElement).data("layout") || null;
		let excludeTax = jQuery(gridElement).data("exclude-tax") || false;
		let sorting = jQuery(gridElement).data("es-sort") || false;
		let collapsable = jQuery(gridElement).data("collapsable") || null;
		let changeButtonTitle = jQuery(gridElement).data("change-button") || null;
		let columns = jQuery(gridElement).data("columns") || null;
		let tagfilters = jQuery(gridElement).data("api-es-tagfilters") || null;
		let queryTagFilters = jQuery(gridElement).data("qf-tags") || null;
		let matchAllTags = jQuery(gridElement).data("match-all-tags") == true || jQuery(gridElement).data("match-all-tags") == "true"
		let packageUpgrade = jQuery(gridElement).data("package-upgrade") == true || jQuery(gridElement).data("package-upgrade") == "true"
		let packageUpgradeTag = jQuery(gridElement).data("package-upgrade-tag") || null
		let tagCategoryGroup = jQuery(gridElement).data("tag-category-group") || null
		let defaultIconDisplay = jQuery(gridElement).data('default-icon-display') || null
		let useDescriptionForName = jQuery(gridElement).data('use-description-name') == true || jQuery(gridElement).data('use-description-name') == "true"
		
		let multiselect = jQuery(gridElement).data('multiselect') == true || jQuery(gridElement).data('multiselect') == "true"

		let tags = tagfilters ? tagfilters.split(',') || [] : []

		if (queryTagFilters && queryTagFilters.length) {
			let queryTagFields = queryTagFilters.split(',')
			for (let tag of queryTagFields) {
				let value = this.findQueryString(tag)
				if (value != null && value.length) {
					tags.push(value)
				}
			}
		}

		if (!layout || !layout.length) layout = null;
		if (!excludeTax || excludeTax == 0) excludeTax = false;
		if (excludeTax == 1) excludeTax = true;
		if (sorting){
			const sortItems = sorting.split(':');
			const sortOrderOptions = ["asc","desc"]
			if(sortItems.length == 2 && sortOrderOptions.includes(sortItems[1])){
				sorting = {[sortItems[0]]:sortItems[1]}
			}else{
				sorting == null;
			}
		}
		const grid = new FirehawkCRMGridPicker(jQuery(gridElement), gridElement.querySelector(".grid"), gridElement.querySelector(".firehawk-crm-pg"), index, route, 8, tags, showInWeb, multiselect, collapsable == true, changeButtonTitle || "Change", tagCategoryGroup)
		if (this.currencySymbol) {
			grid.currencySymbol = this.currencySymbol
		} else {
			grid.currencySymbol = "$"
		}

		if (matchAllTags && tags.length) {
			grid.minimumTagMatch = tags.length
		}
		grid.defaultIconDisplay = defaultIconDisplay
		grid.addToCart = addToCart
		grid.useDescriptionForName = useDescriptionForName
		grid.defaultValue = queryValue
		grid.packageUpgrade = packageUpgrade
		grid.packageUpgradeTag = packageUpgradeTag
		grid.layout = layout
		grid.excludeTax = excludeTax
		if(sorting)grid.sorting = sorting
		grid.columns = columns

		grid.itemSelected = (item, grid) => {
			var isBaseItem = grid.packageUpgradeBaseItem && grid.packageUpgradeBaseItem.id == item.id
			if (grid && grid.addToCart && item.id && !isBaseItem) {
				if (!grid.multiselect && !isBaseItem) {
					for (let key in this.cartItems) {
						if (key.startsWith(`${id}_`)) {
							this.removeFromCart(key)
						}
					}
				}
				var extraParams = item.cartParams || {}
				this.updateCart(`${id}_${item.id}`, item.id, 1, extraParams)
			} else {
				this.removeFromCart(`${id}_${item.id}`)
			}

			this.updatePackagePricingInfo()
		}

		grid.itemDeselected = (item, grid) => {
			if (grid && grid.addToCart) {
				this.removeFromCart(`${id}_${item.id}`)
			}

			this.updatePackagePricingInfo()
		}

		grid.initialise()
		this.grids[id] = grid
	}

	buildHtmlDocument(id) {
		const docElement = document.querySelector(`${this.formElementId} #${id}`)
		if (!docElement) {
			return
		}

		let documentId = jQuery(docElement).data("document") || null;
		const firehawkDoc = new FirehawkCRMHtmlDoc(documentId, jQuery(docElement), docElement.querySelector(".html-content"))

		firehawkDoc.initialise()

		this.htmlDocs[id] = firehawkDoc
	}

	buildAddressPicker(fieldName, defaultCountry) {
		const element = document.querySelector(`${this.formElementId} [name='${fieldName}']`)

		if (!element) {
			return
		}

		let hideCountry = jQuery(element).data("hide-country") == "true" || jQuery(element).data("hide-country") == true
		let defaultValue = jQuery(element).data("defaultvalue") || null;
		let calculateDistanceFromLocations = jQuery(element).data("calc-dist-locations") || null;
		let restrictResultsByState = jQuery(element).data("restrict-state") || null;
		let restrictResultsByCity = jQuery(element).data("restrict-city") || null;
		let disableEdits = jQuery(element).data("disable-edits") == "true" || jQuery(element).data("disable-edits") == true

		if (defaultValue && typeof defaultValue == "string") {
			try {
				defaultValue = JSON.parse(defaultValue)
			} catch(error) {
				console.error(error)
			}
		}

		if (calculateDistanceFromLocations && typeof calculateDistanceFromLocations == "string") {
			try {
				calculateDistanceFromLocations = JSON.parse(calculateDistanceFromLocations)
			} catch(error) {
				console.error(error)
			}
		}

		const addressPicker = new FirehawkCRMAddressPicker(element.querySelector(".address-picker"), defaultCountry, hideCountry, defaultValue, calculateDistanceFromLocations, disableEdits, restrictResultsByState, restrictResultsByCity)
		addressPicker.addressChanged = async (address) => {
			let validatePostcode = jQuery(element).hasClass("geo-validate-address")

			var hasErrors = false
			if (validatePostcode) {
				if (address) {
					this.validateAddressPostcode(address, element);
				} else {
					jQuery(element).removeClass("valid").removeClass("invalid").removeClass("verifying")
					jQuery(element).siblings(".error-label").addClass("d-none").text("")
					hasErrors = false
				}
			} else if (address) {
				if (!address.postcode || !address.postcode.trim().length) {
					let invalidLabel = "Postcode is required to validate address"
					jQuery(element).parent().addClass("error")
					jQuery(element).siblings(".error-label").removeClass("d-none").html(invalidLabel)
					hasErrors = true
				} else {
					jQuery(element).parent().removeClass("error")
					jQuery(element).siblings(".error-label").addClass("d-none").text("")
					hasErrors = false
				}

				if (addressPicker.didRestrictAddress) {
					let invalidLabel = jQuery(element).data("restricted-label") || "Unable to validate field"
					jQuery(element).removeClass("valid").addClass("invalid")
					let errorLabel = jQuery(element).siblings(".text-danger")
					errorLabel.removeClass("d-none")
					errorLabel.html(invalidLabel)
					hasErrors = true
				} else {
					jQuery(element).addClass("valid").removeClass("invalid")
				}
				
				if (!hasErrors && addressPicker.calculateDistanceFromLocations && addressPicker.calculateDistanceFromLocations.length) {
					jQuery(element).addClass("verifying")
					addressPicker.runDistanceCalculationChecks(() => {
						jQuery(element).removeClass("verifying")
						this.triggerCheckRelations();
						this.debounceChangeCheckForm();
					})
				} else {
					this.triggerCheckRelations();
					this.debounceChangeCheckForm()
				}
			} else {
				jQuery(element).siblings(".text-danger").addClass("d-none")
				addressPicker.distanceCalculations = {}
				this.triggerCheckRelations();
				this.debounceChangeCheckForm()
			}
		}

		this.addressPickers[fieldName] = addressPicker
	}

	validateAddressPostcode(address, element) {
		jQuery(element).addClass("verifying")

		let invalidLabel = jQuery(element).data("invalid-label") || "Unable to validate field"
		let errorLabel = jQuery(element).siblings(".text-danger")
		let fieldSpinner = jQuery(element).siblings(".field-spinner")

		fieldSpinner.removeClass("d-none")
		errorLabel.addClass("d-none")

		let defaultCountry = jQuery(element).data("country") || null
		let searchDistance = jQuery(element).data("distance") || "15mi"
		let category = jQuery(element).data("category") || null
		let saveResultField = jQuery(element).data("save-result-field") || null
		let tagFilters = jQuery(element).data("geo-tags")

		var tags = tagFilters ? tagFilters.split(',') || [] : []

		if (!address.postcode || !address.postcode.trim().length) {
			jQuery(element).removeClass("valid").addClass("invalid")
			errorLabel.removeClass("d-none")
			errorLabel.html("Postcode is required to validate address")
			return
		}
		
		var params = {
			postcode: address.postcode || null,
			country: defaultCountry,
			distance: searchDistance,
			category: category,
			tags: tags
		}
		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'validate_sup_geo_field',
				params: params
			}
		}).done((result) => {
			var fieldValid = result && result.valid == true
			jQuery(element).removeClass("verifying")

			if (fieldValid) {
				jQuery(element).addClass("valid").removeClass("invalid")
				errorLabel.addClass("d-none")
			} else {
				jQuery(element).removeClass("valid").addClass("invalid")
				errorLabel.removeClass("d-none")
				errorLabel.html(invalidLabel)
			}

			if (saveResultField) {
				this.extraFormData[saveResultField] = result && result.value || null
			}
		}).fail(function (xhr, status, error) {
			console.error(error)
			jQuery(element).removeClass("verifying")
			jQuery(element).removeClass("valid").addClass("invalid")
			// jQuery(formElement).removeClass("valid").addClass("invalid")

			errorLabel.removeClass("d-none")
			errorLabel.html(invalidLabel)

			if (saveResultField) {
				this.extraFormData[saveResultField] = null
			}
			this.triggerCheckRelations();
		}).always(function () {
			fieldSpinner.addClass("d-none")
		});
	}

	updateGridPickers(page) {
		var me = this
		jQuery(page).find(".firehawk-crm-form-grid-picker").each(function (index) {
			const gridId = jQuery(this).attr('id')
			const grid = me.grids[gridId]

			if (grid) {
				setTimeout(function () {
					grid.updateLayout()
				}, 200)
			}
		})
	}

	gridPickerValues() {
		var me = this
		var values = []
		jQuery(`${this.formElementId} .firehawk-crm-form-grid-picker`).each(function (index) {
			const elementId = jQuery(this).attr('id')
			const picker = me.grids[elementId]

			if (picker) {
				if (picker.multiselect) {
					values.push({
						id: elementId,
						value: picker.selectedItems.map(s => s.id).filter(id => id)
					})
				} else {
					if (picker.selectedItem && picker.selectedItem.id) {
						values.push({
							id: elementId,
							value: picker.selectedItem.id
						})
					}
				}
			}
		})

		return values
	}

	addressPickerValues() {
		var me = this
		var values = []
		jQuery(`${this.formElementId} .firehawk-crm-form-address-picker`).each(function (index) {
			const elementId = jQuery(this).attr('name')
			const picker = me.addressPickers[elementId]

			if (picker && picker.selectedAddress) {
				values.push({
					id: elementId,
					value: picker.selectedAddress
				})
			}
		})

		return values
	}

	findGoogleAddressPart(address_components, query, val = null) {
		for (let attr of address_components) {
			for (let type of attr.types) {
				if (Array.isArray(query) && query.filter(q => q == type).length > 0) {
					return val ? attr[val] : attr;
				} else if (type === query) {
					return val ? attr[val] : attr;
				}
			}
		}
		return null;
	}

	jumpToFormPage(pageId, jumpDirection) {
		let me = this;

		if (this.checkForm()) {
			var currentForm = jQuery(`${this.formElementId} .firehawk-crm-form-page.active`);

			var callback = () => {
				this.checkPageRelations()
				jQuery(currentForm).removeClass('active');

				jQuery(`${this.formElementId} .firehawk-crm-form-page`).each(function () {
					var element = jQuery(this)

					if (element.data('page-id') == pageId) {
						element.addClass('active');
						me.updateGridPickers(element)
						if (element.hasClass('has-checkout')) {
							me.loadCheckout();
						}

						me.checkActivePageBlocked()
					}
				});

				this.checkRelations()
				
				this.checkMergeLabels()
				this.updatePageWizard()
				this.updatePageHtmlDocuments()
			}

			if (this.savePages) {
				this.saveCurrentPage(callback)
			} else {
				callback()
			}
		}
	}

	checkForm(clearOnly = false) {
		var me = this
		var validForm = true;

		jQuery(`${this.formElementId} .form-element[data-required]:visible`).each(function (index) {
			var valid = true;
			var pattern = jQuery(this).data("pattern");
			var elements = jQuery(this).find("> input:not([type=radio], > [type=checkbox]), > select, > div > select, > textarea");

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var value = jQuery(element).val();

				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						var checkValid = reg.test(value)
						if (!checkValid) {
							valid = false

							if (!clearOnly) {
								jQuery(this).addClass('error')
								jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
							}
						} else {
							jQuery(this).removeClass('error')
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}
					} else if (jQuery(element).data("mask-format") && jQuery(element).hasClass("date-input")) {
						var maskFormat = "DD/MM/YYYY"
						if (jQuery(element).data("mask-format")) {
							maskFormat = jQuery(element).data("mask-format").toUpperCase()
						}
						var date = moment.utc(value, maskFormat)

						if (!date || date.isValid() == false) {
							valid = false
							if (!clearOnly) {
								jQuery(this).addClass('error')
								if (jQuery(element).siblings(".error-label").hasClass("d-none")) {
									jQuery(element).siblings(".error-label").removeClass("d-none").text("Date is invalid")
								}
							}
						} else if (!jQuery(element).hasClass("invalid")) {
							jQuery(this).removeClass('error')
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}
					} else {
						if (jQuery(element).data("match-field-key")) {
							var parentKey = jQuery(this).data("parent-key")
							var fieldKey = jQuery(element).data("match-field-key")
							if (parentKey) fieldKey = `${parentKey}[${fieldKey}]`
							let matchField = jQuery(`${me.formElementId} [name="${fieldKey}"]`)
							let fieldLabel = matchField.parent(".form-element").find(".control-label").text() || null

							var matchError = jQuery(element).data("match-field-error") || `Field should match${fieldLabel ? " field " + fieldLabel : "" }`
							var matchValue = matchField.val()

							if (!matchValue || matchValue && matchValue != value) {
								valid = false
								if (!clearOnly) {
									jQuery(this).addClass('error')
									jQuery(element).siblings(".error-label").removeClass("d-none").text(matchError)
								}
							} else {
								jQuery(this).removeClass('error')
								jQuery(element).siblings(".error-label").addClass("d-none").text("")
							}
						} else {
							jQuery(this).removeClass('error')
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}

					}
				} else {
					valid = false
					if (!clearOnly) {
						jQuery(this).addClass('error')
						jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
					}
				}
			}
			
			var validatedRadioButtons = [];

			elements = jQuery(this).find("input[type=radio]:checked, input[type=checkbox]:checked");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var pattern = jQuery(this).data("pattern");
				var value = jQuery(element).val();
				var fieldName = jQuery(element).attr('name');
				validatedRadioButtons.push(fieldName)
				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						var checkValid = reg.test(value)
						if (!checkValid) {
							valid = false
							if (!clearOnly) {
								jQuery(element).parents(".form-element").first().addClass('error')
								jQuery(element).addClass('error')
								jQuery(element).parents(".form-element").first().find(".error-label").removeClass("d-none").text("Required")
							}
						} else {
							jQuery(element).parents(".form-element").first().find(".error-label").addClass("d-none").text("")
						}
					} else {
						jQuery(element).parents(".form-element").first().find(".error-label").addClass("d-none").text("")
						jQuery(element).parents(".form-element").first().removeClass('error')
						jQuery(element).removeClass('error')
					}
				} else {
					if (!clearOnly) {
						jQuery(element).parents(".form-element").first().find(".error-label").removeClass("d-none").text("Required")
						jQuery(element).parents(".form-element").first().addClass('error')
						jQuery(element).addClass('error')
					}
				}
			}

			elements = jQuery(this).find("input[type=radio]:not(:checked), input[type=checkbox]:not(:checked)");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');
				var elementHidden = me.checkElementHidden(jQuery(element).parents(".form-element"))

				if (!validatedRadioButtons.includes(fieldName) && !elementHidden) {
					valid = false
					if (!clearOnly) {
						jQuery(element).parents(".form-element").first().find(".error-label").removeClass("d-none").text("Required")
						jQuery(element).parents(".form-element").first().addClass('error')
						jQuery(element).addClass('error')
					}
				}
			}

			elements = jQuery(this).find(".tag-picker");

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');

				var count = jQuery(element).find(".tag.selected").length

				if (count == 0) {
					valid = false
					if (!clearOnly) {
						jQuery(element).siblings(".error-label").removeClass("d-none").text("You must select at least one")
						jQuery(this).addClass('error')
					}
				}
			}

			elements = jQuery(this).find(".sup-geo-field");

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var isValid = jQuery(element).hasClass("valid")

				if (!isValid) {
					valid = false
					// jQuery(element).siblings(".error-label").removeClass("d-none").text("You must select at least one")
					if (!clearOnly) {
						jQuery(this).addClass('error')
					}
				}
			}

			elements = jQuery(this).find(".firehawk-crm-form-address-picker");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');

				const picker = me.addressPickers[fieldName]

				if (picker && (!picker.selectedAddress || !picker.selectedAddress.postcode || !picker.selectedAddress.postcode.length)) {
					valid = false
					if (!clearOnly) {
						let invalidLabel = jQuery(element).data("invalid-label") || "Please check the address and try again."

						if (picker.selectedAddress && (!picker.selectedAddress.postcode || !picker.selectedAddress.postcode.trim().length)) {
							invalidLabel = "Postcode is required to validate address"
						}

						jQuery(element).siblings(".error-label").removeClass("d-none").html(invalidLabel)
						jQuery(this).addClass('error')
					}
				} else {
					let address = picker.selectedAddress
					let validatePostcode = jQuery(element).hasClass("geo-validate-address")

					if (validatePostcode && address) {
						let hasInvalidAddress = jQuery(element).hasClass("invalid")
						let verifyingAddress = jQuery(element).hasClass("verifying")
						if (hasInvalidAddress || verifyingAddress) {
							valid = false
						}
					} else if (picker.didRestrictAddress) {
						valid = false
					} else {
						if (jQuery(element).hasClass("verifying")) {
							valid = false
						} else {
							jQuery(this).removeClass("error")
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}
					}
				}
			}

			elements = jQuery(this).find(".firehawk-crm-form-grid-picker");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('id');

				const picker = me.grids[fieldName]

				if (picker) {
					var hasValue = false
					if (picker.multiselect) {
						hasValue = picker.selectedItems.length > 0
					} else {
						hasValue = picker.selectedItem && picker.selectedItem.id
					}

					if (hasValue) {
						jQuery(this).removeClass("error")
						jQuery(element).siblings(".error-label").addClass("d-none").text("")
					} else {
						valid = false
						if (!clearOnly) {
							jQuery(element).siblings(".error-label").removeClass("d-none").text("Please select a valid item")
							jQuery(this).addClass('error')
						}
					}
				}
			}

			elements = jQuery(this).find(".time-picker-dropdown");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');
				var value = jQuery(element).simpleTimePicker("getTime");

				if (!value || !value.length) {
					valid = false
					if (!clearOnly) {
						jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
						jQuery(this).addClass('error')
					}
				} else {
					jQuery(element).siblings(".error-label").addClass("d-none").text("")
					jQuery(this).removeClass('error')
				}
			}

			if (!valid) {
				validForm = false;
			}
		})

		jQuery(`${this.formElementId} .form-element .iti input.form-control:visible`).each(function (index) {
			var formElement = jQuery(this).parents(".form-element").first()
			var fieldRequired = formElement.data("required") == true
			
			var value = jQuery(this).val();

			const iti = window.intlTelInput.getInstance(this);
			const isValid = iti.isValidNumber();

			var fieldValid = true
			var validationError = null
			var showErrors = !clearOnly
			if (fieldRequired && (!value || !value.length)) {
				fieldValid = false
				validationError = "Required"
			} else if (isValid) {
				fieldValid = true
			} else {
				const error = iti.getValidationError();
				var hasValue = value && value.length > 0 ? true : false
				if (error === window.intlTelInput.utils.validationError.TOO_SHORT && hasValue) {
					validationError = "Phone number is too short";
					showErrors = true
					fieldValid = false
				} else if (error === window.intlTelInput.utils.validationError.TOO_LONG) {
					validationError = "Phone number is too long"
					showErrors = true
					fieldValid = false
				} else if (error === window.intlTelInput.utils.validationError.INVALID_COUNTRY_CODE) {
					validationError = "Invalid country code"
					showErrors = true
					fieldValid = false
				} else if (error != null && fieldRequired) {
					validationError = "Required"
					fieldValid = false
				}
			}

			if (!fieldValid) {
				validForm = false
				if (showErrors) {
					jQuery(this).addClass('error')
					formElement.addClass("error")
					formElement.find(".error-label").removeClass("d-none").text(validationError)
				}
			} else {
				jQuery(this).removeClass('error')
				formElement.removeClass("error")
				formElement.find(".error-label").addClass("d-none").text("")
			}
		})

		jQuery(`${this.formElementId} .form-element input[type="date"]:visible, ${this.formElementId} .form-element input[type="datetime-local"]:visible, ${this.formElementId} .form-element input.date-input:visible`).each(function (index) {
			var fieldRequired = jQuery(this).parent().data("required") == true
			var datemin = jQuery(this).data("datemin");
			var datemax = jQuery(this).data("datemax");
			var value = jQuery(this).val();
			var currDate = moment.utc(value, "DD/MM/YYYY")
			if (jQuery(this).attr("type") == "date") {
				currDate = moment.utc(value, "YYYY/MM/DD")
			} else if (jQuery(this).attr("type") == "datetime-local") {
				currDate = moment.utc(value, "YYYY-MM-DDTHH:mm")
			}

			var dateValid = true
			var validationError = null

			if (value && (datemin || datemax)) {
				if (datemin == "current-date") {
					var difference = currDate.diff(moment.utc(), 'days');
					if (difference < 0) {
						validForm = false;
						dateValid = false
						validationError = "Must not be less then today"
					}
				} else if (datemin == "48-hours") {
					var timeFomNow = moment.utc().startOf("day").add(48, "hours")
					var difference = currDate.diff(timeFomNow, 'days');
					if (difference < 0) {
						validForm = false;
						dateValid = false
						validationError = "Must be greater then 48 hours from now"
					}
				} else if (datemin == "24-hours") {
					var timeFomNow = moment.utc().startOf("day").add(24, "hours")
					var difference = currDate.diff(timeFomNow, 'days');
					if (difference < 0) {
						validForm = false;
						dateValid = false
						validationError = "Must be greater then 24 hours from now"
					}
				} else if (datemin && moment.utc(datemin).isValid()) {
					var minDate = moment.utc(datemin)
					var difference = currDate.diff(minDate, 'days');
					if (difference < 0) {
						validForm = false;
						dateValid = false
					}
				}

				if (datemax == "current-date") {
					var difference = currDate.diff(moment.utc(), 'days');
					if (difference > 0) {
						validForm = false;
						dateValid = false
						validationError = "Must not be greater then today"
					}
				} else if (datemax == "48-hours") {
					var timeFomNow = moment.utc().startOf("day").add(48, "hours")
					var difference = currDate.diff(timeFomNow, 'days');
					if (difference > 0) {
						validForm = false;
						dateValid = false
						validationError = "Must be less then 48 hours from now"
					}
				} else if (datemax == "24-hours") {
					var timeFomNow = moment.utc().startOf("day").add(24, "hours")
					var difference = currDate.diff(timeFomNow, 'days');
					if (difference > 0) {
						validForm = false;
						dateValid = false
						validationError = "Must be less then 24 hours from now"
					}
				} else if (datemax && moment.utc(datemax).isValid()) {
					var minDate = moment.utc(datemax)
					var difference = currDate.diff(minDate, 'days');
					if (difference > 0) {
						validForm = false;
						dateValid = false
					}
				}
			} else if (fieldRequired) {
				if (!value || !dateValid) {
					if (!clearOnly) {
						dateValid = false
						validationError = "Required"
					}
	
					validForm = false
				}
			}

			if (dateValid) {
				jQuery(this).parent().removeClass('error')
				jQuery(this).removeClass("invalid")
				jQuery(this).siblings(".error-label").addClass("d-none").text("")
			} else {
				jQuery(this).parent().addClass('error')
				jQuery(this).addClass("invalid")
				jQuery(this).siblings(".error-label").removeClass("d-none").text(validationError || "Date is invalid")
			}
		})

		jQuery(`${this.formElementId} .form-element:not([data-required]):visible`).each(function (index) {
			var valid = true;
			var pattern = jQuery(this).data("pattern");
			var elements = jQuery(this).find("input:not([type=radio], [type=checkbox]), select, textarea");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var value = jQuery(element).val();
				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						valid = reg.test(value)
						if (!valid) {
							jQuery(this).addClass('error')
						}
					} else {
						valid = true;
					}
				} else {
					valid = true;
				}
			}

			if (!valid || !validForm) {
				validForm = false;
			}

		})
		return validForm;
	}

	validateFormPage(pageId) {
		var me = this
		var validForm = true;

		jQuery(`${this.formElementId} .firehawk-crm-form-page[data-page-id='${pageId}'] .form-element[data-required]:visible`).each(function (index) {
			var valid = true;
			var pattern = jQuery(this).data("pattern");
			var elements = jQuery(this).find("> input:not([type=radio], > [type=checkbox]), > select, > div > select, > textarea");

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var value = jQuery(element).val();

				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						var checkValid = reg.test(value)
						if (!checkValid) {
							jQuery(this).addClass('error')
							jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
							valid = false
						} else {
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}
					} else if (jQuery(element).data("mask-format") && jQuery(element).hasClass("date-input")) {
						var maskFormat = "DD/MM/YYYY"
						if (jQuery(element).data("mask-format")) {
							maskFormat = jQuery(element).data("mask-format").toUpperCase()
						}
						var date = moment.utc(value, maskFormat)

						if (!date || date.isValid() == false) {
							valid = false
							jQuery(this).addClass('error')
							if (jQuery(element).siblings(".error-label").hasClass("d-none")) {
								jQuery(element).siblings(".error-label").removeClass("d-none").text("Date is invalid")
							}
						} else if (!jQuery(element).hasClass("invalid")) {
							jQuery(this).removeClass('error')
							jQuery(element).siblings(".error-label").addClass("d-none").text("")
						}
					} else {
						jQuery(this).removeClass('error')
						jQuery(element).siblings(".error-label").addClass("d-none").text("")
					}
				} else {
					jQuery(this).addClass('error')
					jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
					valid = false
				}
			}

			var validatedRadioButtons = [];

			elements = jQuery(this).find("input[type=radio]:checked, input[type=checkbox]:checked");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var pattern = jQuery(this).data("pattern");
				var value = jQuery(element).val();
				var fieldName = jQuery(element).attr('name');
				validatedRadioButtons.push(fieldName)
				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						var checkValid = reg.test(value)
						if (!checkValid) {
							valid = false
							jQuery(this).addClass('error')
							jQuery(element).parent().parent().siblings(".error-label").removeClass("d-none").text("Required")
						} else {
							jQuery(element).parent().parent().siblings(".error-label").addClass("d-none").text("")
						}
					} else {
						jQuery(element).parent().parent().siblings(".error-label").addClass("d-none").text("")
						jQuery(element).removeClass('error')
					}
				} else {
					jQuery(element).parent().parent().siblings(".error-label").removeClass("d-none").text("Required")
					jQuery(element).addClass('error')
				}
			}

			elements = jQuery(this).find("input[type=radio]:not(:checked), input[type=checkbox]:not(:checked)");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');
				if (!validatedRadioButtons.includes(fieldName)) {
					valid = false
					jQuery(element).parent().parent().siblings(".error-label").removeClass("d-none").text("Required")
					jQuery(element).addClass('error')
				}
			}

			elements = jQuery(this).find(".tag-picker");

			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');

				var count = jQuery(element).find(".tag.selected").length

				if (count == 0) {
					valid = false
					jQuery(element).siblings(".error-label").removeClass("d-none").text("You must select at least one")
					jQuery(this).addClass('error')
				}
			}

			elements = jQuery(this).find(".firehawk-crm-form-address-picker");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');

				const picker = me.addressPickers[fieldName]

				if (picker && !picker.selectedAddress) {
					valid = false
					jQuery(element).siblings(".error-label").removeClass("d-none").text("Please select a valid address")
					jQuery(this).addClass('error')
				} else {
					jQuery(this).removeClass("error")
					jQuery(element).siblings(".error-label").addClass("d-none").text("")
				}
			}

			elements = jQuery(this).find(".firehawk-crm-form-grid-picker");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('id');

				const picker = me.grids[fieldName]

				var hasValue = false
				if (picker.multiselect) {
					hasValue = picker.selectedItems.length > 0
				} else {
					hasValue = picker.selectedItem && picker.selectedItem.id
				}

				if (hasValue) {
					jQuery(this).removeClass("error")
					jQuery(element).siblings(".error-label").addClass("d-none").text("")
				} else {
					valid = false
					jQuery(element).siblings(".error-label").removeClass("d-none").text("Please select a valid item")
					jQuery(this).addClass('error')
				}
			}

			elements = jQuery(this).find(".time-picker-dropdown");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var fieldName = jQuery(element).attr('name');
				var value = jQuery(element).simpleTimePicker("getTime");

				if (!value || !value.length) {
					valid = false
					jQuery(element).siblings(".error-label").removeClass("d-none").text("Required")
					jQuery(this).addClass('error')
				}
			}

			jQuery(this).find('.form-element input[type="date"]:visible, .form-element input.date-input:visible').each(function (index) {
				var fieldRequired = jQuery(this).parent().data("required") == true
				var datemin = jQuery(this).data("datemin");
				var datemax = jQuery(this).data("datemax");
				var value = jQuery(this).val();
				var currDate = moment.utc(value, "DD/MM/YYYY")
				if (jQuery(this).attr("type") == "date") {
					currDate = moment.utc(value, "YYYY/MM/DD")
				}

				var dateValid = true
				var validationError = null

				if (value && (datemin || datemax)) {
					if (datemin == "current-date") {
						var difference = currDate.diff(moment.utc(), 'days');
						if (difference < 0) {
							valid = false;
							dateValid = false
							validationError = "Must not be less then today"
						}
					} else if (datemin == "48-hours") {
						var timeFomNow = moment.utc().startOf("day").add(48, "hours")
						var difference = currDate.diff(timeFomNow, 'days');
						if (difference < 0) {
							valid = false;
							dateValid = false
							validationError = "Must be greater then 48 hours from now"
						}
					} else if (datemin == "24-hours") {
						var timeFomNow = moment.utc().startOf("day").add(24, "hours")
						var difference = currDate.diff(timeFomNow, 'days');
						if (difference < 0) {
							valid = false;
							dateValid = false
							validationError = "Must be greater then 24 hours from now"
						}
					} else if (moment.utc(datemin).isValid()) {
						var minDate = moment.utc(datemin)
						var difference = currDate.diff(minDate, 'days');
						if (difference < 0) {
							valid = false;
							dateValid = false
						}
					}

					if (datemax == "current-date") {
						var difference = currDate.diff(moment.utc(), 'days');
						if (difference > 0) {
							valid = false;
							dateValid = false
							validationError = "Must not be greater then today"
						}
					} else if (datemax == "48-hours") {
						var timeFomNow = moment.utc().startOf("day").add(48, "hours")
						var difference = currDate.diff(timeFomNow, 'days');
						if (difference > 0) {
							valid = false;
							dateValid = false
							validationError = "Must be less then 48 hours from now"
						}
					} else if (datemax == "24-hours") {
						var timeFomNow = moment.utc().startOf("day").add(24, "hours")
						var difference = currDate.diff(timeFomNow, 'days');
						if (difference > 0) {
							valid = false;
							dateValid = false
							validationError = "Must be less then 24 hours from now"
						}
					} else if (moment.utc(datemax).isValid()) {
						var minDate = moment.utc(datemax)
						var difference = currDate.diff(minDate, 'days');
						if (difference > 0) {
							valid = false;
							dateValid = false
						}
					}
				} else if (fieldRequired) {
					dateValid = false
					validationError = "Required"
				}

				if (dateValid) {
					jQuery(this).parent().removeClass('error')
					jQuery(this).removeClass("invalid")
					jQuery(this).siblings(".error-label").addClass("d-none").text("")
				} else {
					jQuery(this).parent().addClass('error')
					jQuery(this).addClass("invalid")
					jQuery(this).siblings(".error-label").removeClass("d-none").text(validationError || "Date is invalid")
				}
			})

			if (!valid) {
				validForm = false;
			}
		})

		jQuery(`${this.formElementId} .firehawk-crm-form-page[data-page-id='${pageId}'] .form-element:not([data-required]):visible`).each(function (index) {
			var valid = true;
			var pattern = jQuery(this).data("pattern");
			var elements = jQuery(this).find("input:not([type=radio], [type=checkbox]), select, textarea");
			for (var i = 0; i < elements.length; ++i) {
				var element = elements[i];
				var value = jQuery(element).val();
				if (value && value.length) {
					if (pattern && pattern.length) {
						var reg = new RegExp(pattern);
						valid = reg.test(value)
						if (!valid) {
							jQuery(this).addClass('error')
						}
					} else {
						valid = true;
					}
				} else {
					valid = true;
				}
			}

			if (!valid || !validForm) {
				validForm = false;
			}
		})

		return validForm;
	}

	toJSONString(form) {
		var obj = {};
		var elements = jQuery(this.formElementId).find("input:not([type=radio], [type=checkbox]), select, textarea");
		for (var i = 0; i < elements.length; ++i) {
			var element = elements[i];
			var name = element.name;
			var value = element.value;

			if (name) {
				obj[name] = value;
			}
		}

		elements = jQuery(this.formElementId).find("input[type=radio]:checked, input[type=checkbox]:checked");
		for (var i = 0; i < elements.length; ++i) {
			var element = elements[i];
			console.log(element)
			var name = element.name;
			var value = element.value;

			console.log(name, value)

			if (name) {
				obj[name] = value;
			}
		}

		return JSON.stringify(obj);
	}

	checkCondition(whenItem, connective, section, parentKey) {
		// console.log(whenItem, connective)
		if (!whenItem || !whenItem['id'] || !whenItem['id'].length || !whenItem['operator'] || !whenItem['operator'].length || whenItem['value'] == null) {
			return false;
		}

		var conditionsMet = false;
		var fieldKey = whenItem['id']
		if (parentKey && parentKey.length) {
			fieldKey = `${parentKey}[${whenItem['id']}]`
		}

		var element = jQuery(`.form-element [name='${fieldKey}']`);
		var elementType = ''

		if (parentKey && !element.length) {
			element = jQuery(`.form-element [name='${whenItem['id']}']`);
		}
		if (element.length >= 1) {
			elementType = element[0].type
		} else {
			elementType = element.type
		}

		var elementValue = element.val();

		if (this.grids && this.grids[fieldKey]) {
			if (this.grids[fieldKey].multiselect) {
				elementValue = this.grids[fieldKey].selectedItems.map(s => s.id).filter(id => id)
			} else {
				elementValue = this.grids[fieldKey].selectedItemId
			}
		} else if (this.selectedPackages && this.selectedPackages[fieldKey]) {
			elementValue = this.selectedPackages[fieldKey]
		} else if (this.addressPickers && this.addressPickers[fieldKey]) {
			let addressPicker = this.addressPickers[fieldKey]
			if (whenItem.checkOriginDistanceKey && addressPicker.distanceCalculations) {
				elementValue = addressPicker.distanceCalculations[whenItem.checkOriginDistanceKey]
			}
		} else if (elementType == "checkbox") {
			element = jQuery(`.form-element [name='${fieldKey}']:checked`);
			elementValue = []
			element.each(function () {
				var value = jQuery(this).val()
				if (value) {
					elementValue.push(value)
				}
			})
		} else if (element.hasClass("time-picker-dropdown")) {
			elementValue = element.simpleTimePicker("getTime");
		}

		if (whenItem["dateType"] && whenItem["dateFormat"]) {
			if (elementValue && elementValue.length) {
				var dateValue = moment(elementValue, whenItem["dateFormat"])

				if (!dateValue.isValid()) {
					elementValue = null
				} else {
					var newValue = moment(elementValue, whenItem["dateFormat"])[whenItem["dateType"]]()
					if (whenItem["dateType"] == "hours") {
						let minutes = moment(elementValue, whenItem["dateFormat"]).minutes()/100
						if (minutes > 0) {
							newValue += minutes
						}
					}

					elementValue = newValue != null ? newValue : null
				}
			} else {
				elementValue = null
			}
			
		}

		var found = false;

		// console.log("CONDTESTING", whenItem, connective, elementValue)

		if (typeof whenItem['value'] === 'string') {
			var elementArray = elementValue instanceof Array
			var relArray = whenItem.value instanceof Array

			if (whenItem['value'] == "null") {
				if (!elementValue || !elementValue.length) {
					found = true;
				}
			} else if (elementValue == null || elementValue == undefined || elementValue == null) {
				found = false;
			} else if ((elementArray && !relArray) && elementValue.includes(whenItem.value)) {
				found = true
			} else if ((!elementArray && relArray) && whenItem.value.filter((v) => elementValue && v && elementValue.includes(v)).length) {
				found = true
			} else if (elementArray && relArray) {
				for (let index = 0; index < whenItem.value.length; index++) {
					var pFound = elementArray.includes(b[index])
					if (pFound) {
						found = pFound
						break;
					}
				}
			} else if (elementValue.includes(whenItem['value'])) {
				found = true;
			}
		} else {
			var whenItemKeys = Object.keys(whenItem['value']);
			for (var k = 0; k < whenItemKeys.length; k++) {
				if (whenItem['value'][whenItemKeys[k]] == "null") {
					if (!elementValue) {
						found = true;
					}
				} else if (whenItem['value'][whenItemKeys[k]] == elementValue) {
					found = true;
				}
			}
		}


		// console.log("elementValue", elementValue, whenItem['value'], whenItem['operator'], found)
		if (whenItem['operator'] && whenItem['operator'].length) {
			switch (whenItem['operator']) {
				case "==":
					if (found) {
						conditionsMet = true
					} else {
						var a = elementValue;
						var b = whenItem['value']

						if (b == "null" && (a == null || typeof a == "string" && !a.length)) {
							return true
						} else if (b == "null" && a) {
							return false
						} else {
							conditionsMet = a == b
						}
					}
					break;
				case "!=":
					if (!found) {
						conditionsMet = true
					} else {
						var a = elementValue;
						var b = whenItem['value']

						if (b == "null" && (a == null || typeof a == "string" && !a.length)) {
							return false
						} else if (b == "null" && a) {
							return true
						} else {
							conditionsMet = a != b
						}
					}
					break;
				case ">":
					var a = elementValue;
					var b = whenItem['value']
					var aArray = Array.isArray(a);
					var bArray = Array.isArray(b);

					if (aArray || bArray) {
						conditionsMet = a.length > b.length
					} else if (a != null && b != null) {
						conditionsMet = a > b
					}
					break;
				case "<":
					var a = elementValue;
					var b = whenItem['value']
					var aArray = Array.isArray(a);
					var bArray = Array.isArray(b);

					if (aArray || bArray) {
						conditionsMet = a.length < b.length
					} else if (a != null && b != null) {
						conditionsMet = a < b
					}
					break;
				case ">=":
					var a = elementValue;
					var b = whenItem['value']
					var aArray = Array.isArray(a);
					var bArray = Array.isArray(b);

					if (aArray || bArray) {
						conditionsMet = a.length >= b.length
					} else if (a != null && b != null) {
						conditionsMet = a >= b
					}
					break;
				case "<=":
					var a = elementValue;
					var b = whenItem['value']
					var aArray = Array.isArray(a);
					var bArray = Array.isArray(b);

					if (aArray || bArray) {
						conditionsMet = a.length <= b.length
					} else if (a != null && b != null) {
						conditionsMet = a <= b
					}
					break;
				default:
					break;
			}
		}
		// console.log("CONDTESTING2", whenItem, connective, elementValue, conditionsMet)
		// console.log(whenItem, connective, conditionsMet, found)
		return conditionsMet;
	}

	getValuesForFields(when, parentKey) {
		var whenKeys = Object.keys(when);
		for (var j = 0; j < whenKeys.length; j++) {
			var whenItem = when[whenKeys[j]];
			if (whenItem && whenItem['when']) {
				whenItem['when'] = this.getValuesForFields(whenItem['when'], parentKey)
			} else if (whenItem && whenItem['id']) {
				var fieldKey = whenItem['id']
				if (parentKey && parentKey.length) {
					fieldKey = `${parentKey}[${whenItem['id']}]`
				}
				var element = jQuery(`.form-element [name='${fieldKey}']`);
				var elementValue = element.val();

				if (this.grids && this.grids[fieldKey]) {
					if (this.grids[fieldKey].multiselect) {
						elementValue = this.grids[fieldKey].selectedItems.map(s => s.id).filter(id => id)
					} else {
						elementValue = this.grids[fieldKey].selectedItemId
					}
				}
				whenItem['fieldValue'] = elementValue;
			}
			when[whenKeys[j]] = whenItem
		}
		return when;
	}

	checkConnectiveRelation(relData, useApi, section, action, parentKey) {
		// console.log(relData, useApi)
		let me = this;
		var connective = relData['connective'] || null;
		var when = relData['when'] || null;

		if (connective != "AND" && connective != "OR") {
			return false;
		}

		var whenKeys = Object.keys(when);
		var conditionsMet = false;

		// console.log(whenKeys)
		if (useApi) {
			relData['when'] = this.getValuesForFields(when, parentKey);
			var body = {
				"relation": relData,
				"team": fcrm_options.team || null
			}
			var bodyString = JSON.stringify(body);
			var htmlElement = jQuery(this);
			jQuery.ajax({
				type: "POST",
				dataType: "json",
				contentType: "application/json",
				url: "https://api.firehawkcrm.com/v2/forms/check-relation",
				data: bodyString,
				success: function (result) {
					conditionsMet = result ? result.valid || false : false;

					if (action && action.length) {
						switch (action.toLowerCase()) {
							case "show":
								if (conditionsMet) {
									me.setDefaultValue(jQuery(section))
									jQuery(section).removeClass('d-none');
								} else {
									jQuery(section).addClass('d-none');
									jQuery(section).find(".form-control").val(null)
								}
								break;
							case "hide":
								if (conditionsMet) {
									jQuery(section).addClass('d-none');
									jQuery(section).find(".form-control").val(null)
								} else {
									me.setDefaultValue(jQuery(section))
									jQuery(section).removeClass('d-none');
								}
								break;
							default:
								break;
						}
					}

				}
			})
		} else {
			for (var j = 0; j < whenKeys.length; j++) {
				var whenItem = when[whenKeys[j]];
				if (whenItem && whenItem['id'] && whenItem['operator']) {
					var whenConditionMet = me.checkCondition(whenItem, connective, section, parentKey);
					if (connective == "AND" && !whenConditionMet) {
						conditionsMet = false
						break;
					} else if (connective == "OR" && whenConditionMet) {
						conditionsMet = true
						break;
					} else {
						conditionsMet = whenConditionMet
					}
				} else if (whenItem && whenItem['connective'] && whenItem['connective'].length && whenItem['when'] && whenItem['when'].length) {
					var whenConditionMet = me.checkConnectiveRelation(whenItem, useApi, section, action, parentKey);
					if (connective == "AND" && !whenConditionMet) {
						conditionsMet = false
						break;
					} else if (connective == "OR" && whenConditionMet) {
						conditionsMet = true
						break;
					} else {
						conditionsMet = whenConditionMet
					}
				} else if (whenItem && whenItem['template'] && whenItem['template'].length) {
					try {
						var row = me.getFormDataObject()
						var compiler = lodash.template(whenItem['template'], { imports: { moment: moment, _: lodash } })
					
						let result; 
						try {
							result = compiler(row);
						} catch (e) {
							result = false;
						}

						result = result ? result.trim() : result
						var whenConditionMet = result && result !== 'false' && result !== '0' && result !== 'null' && result !== 'undefined' ? true : false
						if (connective == "AND" && !whenConditionMet) {
							conditionsMet = false
							break;
						} else if (connective == "OR" && whenConditionMet) {
							conditionsMet = true
							break;
						} else {
							conditionsMet = whenConditionMet
						}
					} catch (error) {
						console.error('Condition template evaluation error:', error)
						if (connective == "AND") {
							conditionsMet = false
							break;
						}
					}
				}
			}
		}

		return conditionsMet;
	}

	mergeTags(content, data, useFlatten = false) {
		var newContent = content
		var tags = newContent.match(/\{}*\{.*?\}\}/g);
		if (tags && tags.length > 0) {
			tags.forEach(tag => {
				var replaced = tag.replace(/[\{\}']+/g, '').trim()
				var keys = useFlatten ? replaced : replaced.split('.')
				var value = data ? lodash.get(data, keys) || '' : ''
				newContent = newContent.replace(tag, value)
			})
		}

		return newContent
	}

	setFieldValue(field, value) {
		if (jQuery(field).hasClass("d-none")) {
			return
		}

		var fieldName = jQuery(field).attr("name")

		if (fieldName && this.grids[fieldName]) {
			const picker = this.grids[fieldName]
			if (picker.packageUpgradeBaseItem && picker.packageUpgradeBaseItem.id == value) {

			} else {
				picker.defaultValue = value
				picker.selectItem(value)
			}

		} else if (jQuery(field).hasClass("form-control")) {
			jQuery(field).val(value)
		}
	}

	setDefaultValue(section) {
		if (!jQuery(section).hasClass("d-none")) {
			return
		}

		jQuery(section).find(".form-control").each(function (index) {
			var control = jQuery(this)
			var defaultValue = control.data("defaultvalue")
			if (defaultValue && control.val() != defaultValue) {
				control.val(defaultValue)
				if (control.hasClass("select2")) { }
			}
		})
	}

	formatTemplateResults(template, data) {
		if (data.loading == true) {
			return data.text
		}

		console.log("lodashTEST", data, template)

		try {
			var compiled = lodash.template(template)
			var results = compiled({
				...data,
				data: data
			})
			console.log("lodashTEST2", results)
			return jQuery(results)
		} catch (error) {
			console.error("lodashTEST3", error)
			return null
		}
	}

	appendFormArray(form_data, values, name) {
		if (!values && name) {
			form_data.append(name, '');
		} else {
			if (typeof values == 'object') {
				for (let key in values) {
					if (typeof values[key] == 'object') {
						this.appendFormArray(form_data, values[key], name ? name + '[' + key + ']' : key);
					} else {
						form_data.append(name ? name + '[' + key + ']' : key, values[key]);
					}
				}
			} else {
				form_data.append(name, values);
			}
		}

		return form_data;
	}

	formatData(formData, forPageSave) {
		var formatted = new FormData();

		formData.forEach(function (value, key) {
			if (!value || value.length == 0) {

			} else {
				var field;
				if (key.endsWith("[]")) {
					field = jQuery('.form-element #' + key.slice(0, -2))
				} else {
					field = jQuery('.form-element #' + key)
				}

				if (!field || !field.length) {
					field = jQuery(`.form-element [name='${key}']`)
				}

				if (field.data("mask-alias") == "datetime") {
					var maskFormat = "DD/MM/YYYY"
					if (field.data("mask-format")) {
						maskFormat = field.data("mask-format").toUpperCase()
					}
					var date = moment.utc(value, maskFormat)
					if (date.isValid()) {
						formatted.append(key, date.format())
					}
				} else if (field.attr("type") == "date") {
					var date = moment.utc(value, "YYYY/MM/DD")
					if (date.isValid()) {
						formatted.append(key, date.format())
					}
				} else if (field.attr("type") == "datetime-local") {
					var date = moment.utc(value, "YYYY-MM-DDTHH:mm")
					if (date.isValid()) {
						formatted.append(key, date.format())
					}
				} else if (field.attr("type") == "time") {
					var date = moment.utc(value, "HH:mm")
					if (date.isValid()) {
						formatted.append(key, date.format())
					}
				} else if (field.hasClass("select2") || field.hasClass("select2-api")) {
					var fieldKey = key
					if (field.prop('multiple') == true) {
						fieldKey += "[]"
						var fieldValue = field.val() || []
						if (!formatted.get(fieldKey)) {
							fieldValue.forEach((item, i) => {
								formatted.append(fieldKey, item)
							});
						}
					} else {
						formatted.append(key, field.val())
					}
				} else if (field.attr("type") == "checkbox" && field.parent().data("multiple") == true) {
					var fieldKey = key + "[]"

					if (!formatted.get(fieldKey)) {
						field.each(function () {
							if (this.checked == true) {
								formatted.append(fieldKey, this.value)
							}
						});
					}
				} else if (field.attr("type") == "file" && forPageSave) {
					if (field.hasClass("changed")) {
						formatted.append(key, value)
					} else {
						//Ignore due to page not being updated
					}
				} else {
					formatted.append(key, value)
				}
			}
		});

		return formatted;
	}

	jsonToFormData(inJSON, inTestJSON, inFormData, parentKey) {
		// http://stackoverflow.com/a/22783314/260665
		// Raj: Converts any nested JSON to formData.
		var form_data = inFormData || new FormData();
		var testJSON = inTestJSON || {};
		for ( var key in inJSON ) {
			// 1. If it is a recursion, then key has to be constructed like "parent.child" where parent JSON contains a child JSON
			// 2. Perform append data only if the value for key is not a JSON, recurse otherwise!
			var constructedKey = key;
			if (parentKey) {
				constructedKey = parentKey + "." + key;
			}

			var value = inJSON[key];
			if (value && value.constructor === {}.constructor) {
				// This is a JSON, we now need to recurse!
				this.jsonToFormData(value, testJSON, form_data, constructedKey);
			} else {
				form_data.append(constructedKey, inJSON[key]);
				testJSON[constructedKey] = inJSON[key];
			}
		}
		return form_data;
	}

	buildConfData() {
		let me = this;

		jQuery('.form-element:not(.d-none) input:not([type="checkbox"])').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var textValue = jQuery(this).val()
				// var confirmationValue = jQuery(this).data("confirmationvalue")
				// console.log("confirmationvalue", id, confirmationValue, jQuery(this).data())
				// if(typeof confirmationValue !== 'undefined') {
				//   var confirmationValueKeys = Object.keys(confirmationValue);
				//   for (var i = 0; i < confirmationValueKeys.length; i++) {
				//     var valid = checkConnectiveRelation(confirmationValue[confirmationValueKeys[i]])
				//     console.log("IS THIS VALID", valid)
				//   }
				// }
				// console.log(id, jQuery(this));
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(textValue)
			}
		})

		jQuery('.form-element input[data-confirmationvalue]').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var textValue = jQuery(this).val()
				var confirmationValue = jQuery(this).data("confirmationvalue")
				if (typeof confirmationValue !== 'undefined') {
					var confirmationValueKeys = Object.keys(confirmationValue);
					for (var i = 0; i < confirmationValueKeys.length; i++) {
						var confirmationValueItem = confirmationValue[confirmationValueKeys[i]]
						var valid = me.checkConnectiveRelation(confirmationValueItem)
						var valueField = confirmationValueItem['valueField']

						if (confirmationValueItem && confirmationValueItem['field'] && confirmationValueItem['field'].length && valueField && valueField.length) {
							jQuery(`.form-element #${confirmationValueItem['field']}.select2-api`).each(function () {

								var objectKey = jQuery(this).val()

								var body = {
									"client": objectKey,
									"team": fcrm_options.team || null
								}
								var bodyString = JSON.stringify(body);
								var htmlElement = jQuery(this);
								jQuery.ajax({
									type: "POST",
									dataType: "json",
									contentType: "application/json",
									url: "https://api.firehawkcrm.com/v2/clients/get",
									data: bodyString,
									success: function (result) {
										var obj = null;
										if (result && result.data) {
											obj = result.data
										} else if (result) {
											obj = result;
										}

										var value = "";
										if (obj && obj[valueField] != null) {
											value = obj[valueField]
										}

										jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(value)
									}
								})
							});
						}

					}
				}
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(textValue)
			}
		})

		jQuery('.form-element:not(.d-none) input[type="checkbox"]:checked').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var textValue = jQuery(this).val()
				if (jQuery(this).is(":checked") && textValue) {
					jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(textValue)
				} else if (jQuery(this).is(":checked")) {
					jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html("Yes")
				} else {
					jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html("No")
				}
			}
		})

		jQuery('.form-element:not(.d-none) textarea').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var textValue = jQuery(this).val()
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(textValue)
			}
		})

		jQuery('.form-element:not(.d-none) input[type="file"]').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var textValue = jQuery(this).val()
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(textValue ? "Provided" : "Not Provided")
			}
		})

		var checkValues = {}
		jQuery('.form-element:not(.d-none) input[checked="checked"]').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				if (!checkValues[id] || !checkValues[id].length) {
					checkValues[id] = [];
				}
				var textValue = jQuery(this).val()
				if (!checkValues[id].includes(textValue)) {
					checkValues[id].push(textValue)
				}
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(checkValues[id].join(", "))
			}
		})

		jQuery('.form-element:not(.d-none) select').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var options = []
				var values = []
				jQuery(this).children("option:selected").each(function () {
					options.push(jQuery(this).val())
					values.push(jQuery(this).text())
				})
				console.log("SELECTED OPTS", options)
				console.log("SELECTED OPTS VAL", values.join(","), id)
				jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(values.join(","))
			}
		})

		jQuery(`.form-element:not(.d-none) .firehawk-crm-form-grid-picker`).each(function (index) {
			const gridId = jQuery(this).attr('id')
			const grid = me.grids[gridId]

			var gridValue = null

			if (grid) {
				if (grid.multiselect) {
					gridValue = grid.selectedItems.map(s => s.name).join(", ")
				} else {
					gridValue = grid.selectedItem && grid.selectedItem.name
				}
			}

			jQuery('.confirmation-field-value[data-idvalue="' + gridId + '"]').html(gridValue)
		});

		jQuery(`.form-element:not(.d-none) .firehawk-crm-form-address-picker`).each(function (index) {
			const elementId = jQuery(this).attr('name')
			const picker = me.addressPickers[elementId]

			if (picker && picker.selectedAddress && picker.selectedAddress.full) {
				jQuery('.confirmation-field-value[data-idvalue="' + elementId + '"]').html(picker.selectedAddress.full)
			}
		});

		jQuery('.form-element:not(.d-none) .checkbox-list').each(function (index) {
			var fieldId = jQuery(this).attr('id');
			if (!fieldId || !fieldId.length) {
				return
			}

			var values = []
			jQuery(this).find('.checkbox-list-item input[type="checkbox"]:checked').each(function () {
				let val = jQuery(this).val()
				if (val) {
					values.push(val)
				}
			})

			jQuery(`.confirmation-field-value[data-idvalue="${fieldId}"]`).html(values.join(", "))
		})

		jQuery('.form-element:not(.d-none) [type="date"]').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var value = jQuery(this).val()
				if (value && value.length) {
					var formattedDate = new Date(value);
					var d = formattedDate.getDate();
					var m = formattedDate.getMonth();
					m += 1; // JavaScript months are 0-11
					var y = formattedDate.getFullYear();
					jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(d + "-" + m + "-" + y)
				}
			}
		})

		jQuery('.form-element:not(.d-none) [type="datetime-local"]').each(function (index) {
			if (jQuery(this) && jQuery(this).attr('id') && jQuery(this).attr('id').length) {
				var id = jQuery(this).attr('name')
				var value = jQuery(this).val()
				if (value && value.length) {
					var formattedDate = new Date(value);
					var d = formattedDate.getDate();
					var m = formattedDate.getMonth();
					m += 1; // JavaScript months are 0-11
					var y = formattedDate.getFullYear();
					jQuery('.confirmation-field-value[data-idvalue="' + id + '"]').html(d + "-" + m + "-" + y)
				}
			}
		})
	}

	updateSelectedTagCounts() {
		jQuery(`${this.formElementId} .tag-picker .tag-group`).each(function (index) {
			const group = jQuery(this)
			var count = jQuery(this).find(".tag.selected").length
			jQuery(this).find(".group-header .badge").html(count > 0 ? count : null)
		})
	}

	onAddNewFieldGroup(groupKey, fullGroupPath, button) {
		let addGroupContainer = button.parent(".group-add-container")
		let currentGroup = addGroupContainer.parent(`[data-groupkey='${groupKey}']`)
		let currentGroupId = currentGroup.data("field-id")
		let currentGroupPosition = +currentGroup.data("group-position");

		// Remove Select 2 from clone an re-init when adding new row
		currentGroup.find(".form-control.select2").each(function(index) {
        	jQuery(this).select2('destroy');
			jQuery(this).removeData("data-select2-id")
			jQuery(this).removeAttr("data-select2-id")
		});

		let newGroup = currentGroup.clone()
		let newGroupPosition = currentGroupPosition + 1

		currentGroup.find(".group-add-container").remove()
		newGroup = this.configureGroupField(newGroup, groupKey, fullGroupPath, newGroupPosition)
		newGroup.data("group-position", newGroupPosition)
		newGroup.attr("data-group-position", newGroupPosition)
		newGroup.find("input:not([type=checkbox]):not([type=radio]), textarea, select").each(function() {
			jQuery(this).val(null);
		})

		newGroup.find("input:checkbox").each(function() {
			jQuery(this).prop("checked", false)
			jQuery(this).parent(".segment-button").removeClass("btn-primary")
			jQuery(this).parent(".segment-button").addClass("btn-light")
		})

		newGroup.insertAfter(currentGroup)

		this.initialiseFormFieldGroup(groupKey)
	}

	onRemoveFieldGroup(groupKey, fullGroupPath, button) {
		let currentGroup = button.parents(`.form-element[data-groupkey='${groupKey}']`)

		let groups = jQuery(this.formElementId).find(`.form-element[data-groupkey="${groupKey}"`)
		let addGroupContainer = groups.find(".group-add-container").detach()

		currentGroup.remove()
		this.reorderFieldGroups(groupKey, addGroupContainer)
	}

	reorderFieldGroups(groupKey, addGroupContainer) {
		var self = this;
		let groups = jQuery(this.formElementId).find(`.form-element[data-groupkey="${groupKey}"`)

		if (!addGroupContainer) {
			addGroupContainer = groups.find(".group-add-container")
			addGroupContainer.detach()
		}

		groups.each(function(index) {
			let group = jQuery(this);
			var groupKey = group.data("groupkey");
			var fullGroupPath = group.data("group-path")

			let newGroupPosition = index
			group = self.configureGroupField(group, groupKey, fullGroupPath, newGroupPosition)
			group.data("group-position", newGroupPosition)
			group.attr("data-group-position", newGroupPosition)

			if (index == groups.length-1 && addGroupContainer.length) {
				group.append(addGroupContainer)
			}
		})
	}

	configureGroupField(group, groupKey, groupPath, groupPosition) {
		let newGroupFieldPath = `${groupPath}[${groupPosition}]`
		let currentGroupPosition = group.data("group-position");
		let groupLabel = group.find(".group-label")
		let groupName = groupLabel.data("group-name");

		groupLabel.html(`${groupName} ${groupPosition+1}`);

		group.find("input, select, .firehawk-crm-form-grid-picker, .firehawk-crm-form-grid-picker, .firehawk-crm-form-html-doc").each(function(index) {
			let name = jQuery(this).attr("name")
			if (name) {
				name = name.replace(`${groupPath}[${currentGroupPosition}]`, newGroupFieldPath)
				jQuery(this).attr("name", name)
			}

			let id = jQuery(this).attr("id")
			if (id) {
				id = id.replace(`${groupPath}[${currentGroupPosition}]`, newGroupFieldPath)
				jQuery(this).attr("id", id)
			}
		})

		group.find(".form-element, .firehawk-crm-form-grid-picker").each(function(index) {
			let fieldId = jQuery(this).data("field-id")
			if (fieldId) {
				fieldId = fieldId.replace(`${groupPath}[${currentGroupPosition}]`, newGroupFieldPath)
				jQuery(this).data("field-id", fieldId)
				jQuery(this).attr("data-field-id", fieldId)
			}

			let parentKey = jQuery(this).data("parent-key")
			if (parentKey) {
				parentKey = parentKey.replace(`${groupPath}[${currentGroupPosition}]`, newGroupFieldPath)
				jQuery(this).data("parent-key", parentKey)
				jQuery(this).attr("data-parent-key", parentKey)
			}
		})

		return group
	}

	getAddressFromAddressPicker(eventTarget) {
		if (!eventTarget) return {};

		let addressPickerForm = eventTarget.children()?.[0]?.children?.[0]?.form;

		if (!addressPickerForm) return {};

		let addressParts = Object.values(addressPickerForm);

		if (!Array.isArray(addressParts)) return {};

		let address = addressParts.reduce((accumulator, item) => {
			if (item.id && item.value) accumulator[item.id] = item.value;

			return accumulator;
		}, {});

		return address;
	}

	checkElementHidden(element) {
		return !jQuery(element).is(":visible") || jQuery(element).css('display') == 'none' ||  jQuery(element).css("visibility") == "hidden"
	}

	initialiseForm() {
		this.setupForm();
		this.addListeners();

		const urlParams = new URLSearchParams(window.location.search);
		this.prefillDataFromQuery(urlParams)
	}

	findQueryString(key) {
		key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx control chars
		var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
		return match && decodeURIComponent(match[1].replace(/\+/g, " "));
	}
}
